{
  "generatedAt": "2026-10-18T19:57:16.690Z",
  "icons": [
    {
      "id": "ages/archaic",
      "file": "ages/archaic-64.webp",
      "file128": "ages/archaic-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/archaic_age_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "ages/classical",
      "file": "ages/classical-64.webp",
      "file128": "ages/classical-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/classical_age_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "ages/heroic",
      "file": "ages/heroic-64.webp",
      "file128": "ages/heroic-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/heroic_age_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "ages/mythic",
      "file": "ages/mythic-64.webp",
      "file128": "ages/mythic-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/mythic_age_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/atlanteans-armory",
      "file": "buildings/atlanteans-armory-64.webp",
      "file128": "buildings/atlanteans-armory-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/armory_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/atlanteans-counter-barracks",
      "file": "buildings/atlanteans-counter-barracks-64.webp",
      "file128": "buildings/atlanteans-counter-barracks-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/buildings/counter_barracks_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/atlanteans-dock",
      "file": "buildings/atlanteans-dock-64.webp",
      "file128": "buildings/atlanteans-dock-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/dock_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/atlanteans-economic-guild",
      "file": "buildings/atlanteans-economic-guild-64.webp",
      "file128": "buildings/atlanteans-economic-guild-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/buildings/economic_guild_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/atlanteans-farm",
      "file": "buildings/atlanteans-farm-64.webp",
      "file128": "buildings/atlanteans-farm-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/farm_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/atlanteans-hesperides-tree",
      "file": "buildings/atlanteans-hesperides-tree-64.webp",
      "file128": "buildings/atlanteans-hesperides-tree-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/buildings/hesperides_tree_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/atlanteans-manor",
      "file": "buildings/atlanteans-manor-64.webp",
      "file128": "buildings/atlanteans-manor-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/buildings/manor_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/atlanteans-market",
      "file": "buildings/atlanteans-market-64.webp",
      "file128": "buildings/atlanteans-market-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/market_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/atlanteans-military-barracks",
      "file": "buildings/atlanteans-military-barracks-64.webp",
      "file128": "buildings/atlanteans-military-barracks-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/buildings/military_barracks_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/atlanteans-mirror-tower",
      "file": "buildings/atlanteans-mirror-tower-64.webp",
      "file128": "buildings/atlanteans-mirror-tower-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/buildings/mirror_tower_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/atlanteans-palace",
      "file": "buildings/atlanteans-palace-64.webp",
      "file128": "buildings/atlanteans-palace-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/buildings/palace_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/atlanteans-sentry-tower",
      "file": "buildings/atlanteans-sentry-tower-64.webp",
      "file128": "buildings/atlanteans-sentry-tower-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/sentry_tower_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/atlanteans-sky-passage",
      "file": "buildings/atlanteans-sky-passage-64.webp",
      "file128": "buildings/atlanteans-sky-passage-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/buildings/sky_passage_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/atlanteans-temple",
      "file": "buildings/atlanteans-temple-64.webp",
      "file128": "buildings/atlanteans-temple-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/temple_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/atlanteans-town-center",
      "file": "buildings/atlanteans-town-center-64.webp",
      "file128": "buildings/atlanteans-town-center-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/buildings/town_center_atlantean_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/atlanteans-village-center",
      "file": "buildings/atlanteans-village-center-64.webp",
      "file128": "buildings/atlanteans-village-center-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/buildings/village_center_atlantean_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/atlanteans-wonder",
      "file": "buildings/atlanteans-wonder-64.webp",
      "file128": "buildings/atlanteans-wonder-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/wonder_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/atlanteans-wooden-wall",
      "file": "buildings/atlanteans-wooden-wall-64.webp",
      "file128": "buildings/atlanteans-wooden-wall-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/wooden_wall_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-armory",
      "file": "buildings/egyptians-armory-64.webp",
      "file128": "buildings/egyptians-armory-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/armory_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-barracks",
      "file": "buildings/egyptians-barracks-64.webp",
      "file128": "buildings/egyptians-barracks-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/buildings/barracks_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-dock",
      "file": "buildings/egyptians-dock-64.webp",
      "file128": "buildings/egyptians-dock-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/dock_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-farm",
      "file": "buildings/egyptians-farm-64.webp",
      "file128": "buildings/egyptians-farm-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/farm_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-granary",
      "file": "buildings/egyptians-granary-64.webp",
      "file128": "buildings/egyptians-granary-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/granary_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-house",
      "file": "buildings/egyptians-house-64.webp",
      "file128": "buildings/egyptians-house-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/house_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-lighthouse",
      "file": "buildings/egyptians-lighthouse-64.webp",
      "file128": "buildings/egyptians-lighthouse-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/buildings/lighthouse_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-lumber-camp",
      "file": "buildings/egyptians-lumber-camp-64.webp",
      "file128": "buildings/egyptians-lumber-camp-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/buildings/lumber_camp_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-market",
      "file": "buildings/egyptians-market-64.webp",
      "file128": "buildings/egyptians-market-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/market_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-migdol-stronghold",
      "file": "buildings/egyptians-migdol-stronghold-64.webp",
      "file128": "buildings/egyptians-migdol-stronghold-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/buildings/migdol_stronghold_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-mining-camp",
      "file": "buildings/egyptians-mining-camp-64.webp",
      "file128": "buildings/egyptians-mining-camp-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/buildings/mining_camp_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-monument-to-gods",
      "file": "buildings/egyptians-monument-to-gods-64.webp",
      "file128": "buildings/egyptians-monument-to-gods-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/buildings/monument_to_gods_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-monument-to-pharaohs",
      "file": "buildings/egyptians-monument-to-pharaohs-64.webp",
      "file128": "buildings/egyptians-monument-to-pharaohs-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/buildings/monument_to_pharaohs_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-monument-to-priests",
      "file": "buildings/egyptians-monument-to-priests-64.webp",
      "file128": "buildings/egyptians-monument-to-priests-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/buildings/monument_to_priests_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-monument-to-soldiers",
      "file": "buildings/egyptians-monument-to-soldiers-64.webp",
      "file128": "buildings/egyptians-monument-to-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/buildings/monument_to_soldiers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-monument-to-villagers",
      "file": "buildings/egyptians-monument-to-villagers-64.webp",
      "file128": "buildings/egyptians-monument-to-villagers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/buildings/monument_to_villagers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-obelisk",
      "file": "buildings/egyptians-obelisk-64.webp",
      "file128": "buildings/egyptians-obelisk-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/buildings/obelisk_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-sentry-tower",
      "file": "buildings/egyptians-sentry-tower-64.webp",
      "file128": "buildings/egyptians-sentry-tower-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/sentry_tower_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-siege-works",
      "file": "buildings/egyptians-siege-works-64.webp",
      "file128": "buildings/egyptians-siege-works-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/buildings/siege_works_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-temple",
      "file": "buildings/egyptians-temple-64.webp",
      "file128": "buildings/egyptians-temple-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/temple_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-town-center",
      "file": "buildings/egyptians-town-center-64.webp",
      "file128": "buildings/egyptians-town-center-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/buildings/town_center_egyptian_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-village-center",
      "file": "buildings/egyptians-village-center-64.webp",
      "file128": "buildings/egyptians-village-center-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/buildings/village_center_egyptian_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-wall",
      "file": "buildings/egyptians-wall-64.webp",
      "file128": "buildings/egyptians-wall-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/wooden_wall_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/egyptians-wonder",
      "file": "buildings/egyptians-wonder-64.webp",
      "file128": "buildings/egyptians-wonder-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/wonder_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/greeks-archery-range",
      "file": "buildings/greeks-archery-range-64.webp",
      "file128": "buildings/greeks-archery-range-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/buildings/archery_range_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/greeks-armory",
      "file": "buildings/greeks-armory-64.webp",
      "file128": "buildings/greeks-armory-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/armory_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/greeks-dock",
      "file": "buildings/greeks-dock-64.webp",
      "file128": "buildings/greeks-dock-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/dock_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/greeks-farm",
      "file": "buildings/greeks-farm-64.webp",
      "file128": "buildings/greeks-farm-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/farm_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/greeks-fortress",
      "file": "buildings/greeks-fortress-64.webp",
      "file128": "buildings/greeks-fortress-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/buildings/fortress_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/greeks-gate",
      "file": "buildings/greeks-gate-64.webp",
      "file128": "buildings/greeks-gate-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/gate_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/greeks-granary",
      "file": "buildings/greeks-granary-64.webp",
      "file128": "buildings/greeks-granary-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/granary_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/greeks-house",
      "file": "buildings/greeks-house-64.webp",
      "file128": "buildings/greeks-house-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/house_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/greeks-market",
      "file": "buildings/greeks-market-64.webp",
      "file128": "buildings/greeks-market-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/market_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/greeks-military-academy",
      "file": "buildings/greeks-military-academy-64.webp",
      "file128": "buildings/greeks-military-academy-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/buildings/military_academy_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/greeks-sentry-tower",
      "file": "buildings/greeks-sentry-tower-64.webp",
      "file128": "buildings/greeks-sentry-tower-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/sentry_tower_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/greeks-stable",
      "file": "buildings/greeks-stable-64.webp",
      "file128": "buildings/greeks-stable-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/buildings/stable_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/greeks-storehouse",
      "file": "buildings/greeks-storehouse-64.webp",
      "file128": "buildings/greeks-storehouse-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/buildings/storehouse_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/greeks-temple",
      "file": "buildings/greeks-temple-64.webp",
      "file128": "buildings/greeks-temple-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/temple_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/greeks-town-center",
      "file": "buildings/greeks-town-center-64.webp",
      "file128": "buildings/greeks-town-center-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/buildings/town_center_greek_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/greeks-village-center",
      "file": "buildings/greeks-village-center-64.webp",
      "file128": "buildings/greeks-village-center-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/buildings/village_center_greek_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/greeks-wall",
      "file": "buildings/greeks-wall-64.webp",
      "file128": "buildings/greeks-wall-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/wooden_wall_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/greeks-wonder",
      "file": "buildings/greeks-wonder-64.webp",
      "file128": "buildings/greeks-wonder-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/wonder_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/norse-armory",
      "file": "buildings/norse-armory-64.webp",
      "file128": "buildings/norse-armory-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/armory_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/norse-dock",
      "file": "buildings/norse-dock-64.webp",
      "file128": "buildings/norse-dock-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/dock_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/norse-dwarven-armory",
      "file": "buildings/norse-dwarven-armory-64.webp",
      "file128": "buildings/norse-dwarven-armory-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/buildings/dwarven_armory_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/norse-farm",
      "file": "buildings/norse-farm-64.webp",
      "file128": "buildings/norse-farm-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/farm_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/norse-great-hall",
      "file": "buildings/norse-great-hall-64.webp",
      "file128": "buildings/norse-great-hall-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/buildings/great_hall_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/norse-hill-fort",
      "file": "buildings/norse-hill-fort-64.webp",
      "file128": "buildings/norse-hill-fort-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/buildings/hill_fort_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/norse-house",
      "file": "buildings/norse-house-64.webp",
      "file128": "buildings/norse-house-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/house_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/norse-longhouse",
      "file": "buildings/norse-longhouse-64.webp",
      "file128": "buildings/norse-longhouse-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/buildings/longhouse_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/norse-market",
      "file": "buildings/norse-market-64.webp",
      "file128": "buildings/norse-market-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/market_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/norse-ox-cart",
      "file": "buildings/norse-ox-cart-64.webp",
      "file128": "buildings/norse-ox-cart-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/ox_cart_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/norse-sentry-tower",
      "file": "buildings/norse-sentry-tower-64.webp",
      "file128": "buildings/norse-sentry-tower-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/sentry_tower_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/norse-temple",
      "file": "buildings/norse-temple-64.webp",
      "file128": "buildings/norse-temple-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/temple_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/norse-town-center",
      "file": "buildings/norse-town-center-64.webp",
      "file128": "buildings/norse-town-center-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/buildings/town_center_norse_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/norse-village-center",
      "file": "buildings/norse-village-center-64.webp",
      "file128": "buildings/norse-village-center-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/buildings/village_center_norse_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/norse-wonder",
      "file": "buildings/norse-wonder-64.webp",
      "file128": "buildings/norse-wonder-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/wonder_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "buildings/norse-wooden-wall",
      "file": "buildings/norse-wooden-wall-64.webp",
      "file128": "buildings/norse-wooden-wall-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/wooden_wall_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/anubis",
      "file": "gods/anubis-64.webp",
      "file128": "gods/anubis-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/minor_gods/anubis_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/anubis-portrait",
      "file": "gods/anubis-portrait-64.webp",
      "file128": "gods/anubis-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/minor_gods/anubis_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/aphrodite",
      "file": "gods/aphrodite-64.webp",
      "file128": "gods/aphrodite-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/minor_gods/aphrodite_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/aphrodite-portrait",
      "file": "gods/aphrodite-portrait-64.webp",
      "file128": "gods/aphrodite-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/minor_gods/aphrodite_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/apollo",
      "file": "gods/apollo-64.webp",
      "file128": "gods/apollo-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/minor_gods/apollo_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/apollo-portrait",
      "file": "gods/apollo-portrait-64.webp",
      "file128": "gods/apollo-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/minor_gods/apollo_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/ares",
      "file": "gods/ares-64.webp",
      "file128": "gods/ares-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/minor_gods/ares_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/ares-portrait",
      "file": "gods/ares-portrait-64.webp",
      "file128": "gods/ares-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/minor_gods/ares_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/artemis",
      "file": "gods/artemis-64.webp",
      "file128": "gods/artemis-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/minor_gods/artemis_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/artemis-portrait",
      "file": "gods/artemis-portrait-64.webp",
      "file128": "gods/artemis-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/minor_gods/artemis_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/athena",
      "file": "gods/athena-64.webp",
      "file128": "gods/athena-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/minor_gods/athena_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/athena-portrait",
      "file": "gods/athena-portrait-64.webp",
      "file128": "gods/athena-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/minor_gods/athena_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/atlas",
      "file": "gods/atlas-64.webp",
      "file128": "gods/atlas-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/minor_gods/atlas_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/atlas-portrait",
      "file": "gods/atlas-portrait-64.webp",
      "file128": "gods/atlas-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/minor_gods/atlas_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/baldr",
      "file": "gods/baldr-64.webp",
      "file128": "gods/baldr-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/minor_gods/baldr_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/baldr-portrait",
      "file": "gods/baldr-portrait-64.webp",
      "file128": "gods/baldr-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/minor_gods/baldr_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/bast",
      "file": "gods/bast-64.webp",
      "file128": "gods/bast-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/minor_gods/bast_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/bast-portrait",
      "file": "gods/bast-portrait-64.webp",
      "file128": "gods/bast-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/minor_gods/bast_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/bragi",
      "file": "gods/bragi-64.webp",
      "file128": "gods/bragi-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/minor_gods/bragi_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/bragi-portrait",
      "file": "gods/bragi-portrait-64.webp",
      "file128": "gods/bragi-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/minor_gods/bragi_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/dionysus",
      "file": "gods/dionysus-64.webp",
      "file128": "gods/dionysus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/minor_gods/dionysus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/dionysus-portrait",
      "file": "gods/dionysus-portrait-64.webp",
      "file128": "gods/dionysus-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/minor_gods/dionysus_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/forseti",
      "file": "gods/forseti-64.webp",
      "file128": "gods/forseti-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/minor_gods/forseti_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/forseti-portrait",
      "file": "gods/forseti-portrait-64.webp",
      "file128": "gods/forseti-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/minor_gods/forseti_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/freyja",
      "file": "gods/freyja-64.webp",
      "file128": "gods/freyja-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/minor_gods/freyja_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/freyja-portrait",
      "file": "gods/freyja-portrait-64.webp",
      "file128": "gods/freyja-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/minor_gods/freyja_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/gaia",
      "file": "gods/gaia-64.webp",
      "file128": "gods/gaia-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/major_gods/gaia_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/gaia-portrait",
      "file": "gods/gaia-portrait-64.webp",
      "file128": "gods/gaia-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/major_gods/gaia_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/hades",
      "file": "gods/hades-64.webp",
      "file128": "gods/hades-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/major_gods/hades_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/hades-portrait",
      "file": "gods/hades-portrait-64.webp",
      "file128": "gods/hades-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/major_gods/hades_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/heimdall",
      "file": "gods/heimdall-64.webp",
      "file128": "gods/heimdall-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/minor_gods/heimdall_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/heimdall-portrait",
      "file": "gods/heimdall-portrait-64.webp",
      "file128": "gods/heimdall-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/minor_gods/heimdall_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/hekate",
      "file": "gods/hekate-64.webp",
      "file128": "gods/hekate-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/minor_gods/hekate_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/hekate-portrait",
      "file": "gods/hekate-portrait-64.webp",
      "file128": "gods/hekate-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/minor_gods/hekate_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/hel",
      "file": "gods/hel-64.webp",
      "file128": "gods/hel-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/minor_gods/hel_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/hel-portrait",
      "file": "gods/hel-portrait-64.webp",
      "file128": "gods/hel-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/minor_gods/hel_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/helios",
      "file": "gods/helios-64.webp",
      "file128": "gods/helios-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/minor_gods/helios_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/helios-portrait",
      "file": "gods/helios-portrait-64.webp",
      "file128": "gods/helios-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/minor_gods/helios_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/hephaestus",
      "file": "gods/hephaestus-64.webp",
      "file128": "gods/hephaestus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/minor_gods/hephaestus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/hephaestus-portrait",
      "file": "gods/hephaestus-portrait-64.webp",
      "file128": "gods/hephaestus-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/minor_gods/hephaestus_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/hera",
      "file": "gods/hera-64.webp",
      "file128": "gods/hera-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/minor_gods/hera_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/hera-portrait",
      "file": "gods/hera-portrait-64.webp",
      "file128": "gods/hera-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/minor_gods/hera_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/hermes",
      "file": "gods/hermes-64.webp",
      "file128": "gods/hermes-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/minor_gods/hermes_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/hermes-portrait",
      "file": "gods/hermes-portrait-64.webp",
      "file128": "gods/hermes-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/minor_gods/hermes_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/horus",
      "file": "gods/horus-64.webp",
      "file128": "gods/horus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/minor_gods/horus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/horus-portrait",
      "file": "gods/horus-portrait-64.webp",
      "file128": "gods/horus-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/minor_gods/horus_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/hyperion",
      "file": "gods/hyperion-64.webp",
      "file128": "gods/hyperion-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/minor_gods/hyperion_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/hyperion-portrait",
      "file": "gods/hyperion-portrait-64.webp",
      "file128": "gods/hyperion-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/minor_gods/hyperion_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/isis",
      "file": "gods/isis-64.webp",
      "file128": "gods/isis-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/major_gods/isis_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/isis-portrait",
      "file": "gods/isis-portrait-64.webp",
      "file128": "gods/isis-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/major_gods/isis_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/kronos",
      "file": "gods/kronos-64.webp",
      "file128": "gods/kronos-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/major_gods/kronos_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/kronos-portrait",
      "file": "gods/kronos-portrait-64.webp",
      "file128": "gods/kronos-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/major_gods/kronos_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/leto",
      "file": "gods/leto-64.webp",
      "file128": "gods/leto-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/minor_gods/leto_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/leto-portrait",
      "file": "gods/leto-portrait-64.webp",
      "file128": "gods/leto-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/minor_gods/leto_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/loki",
      "file": "gods/loki-64.webp",
      "file128": "gods/loki-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/major_gods/loki_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/loki-portrait",
      "file": "gods/loki-portrait-64.webp",
      "file128": "gods/loki-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/major_gods/loki_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/nephthys",
      "file": "gods/nephthys-64.webp",
      "file128": "gods/nephthys-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/minor_gods/nephthys_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/nephthys-portrait",
      "file": "gods/nephthys-portrait-64.webp",
      "file128": "gods/nephthys-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/minor_gods/nephthys_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/njord",
      "file": "gods/njord-64.webp",
      "file128": "gods/njord-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/minor_gods/njord_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/njord-portrait",
      "file": "gods/njord-portrait-64.webp",
      "file128": "gods/njord-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/minor_gods/njord_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/oceanus",
      "file": "gods/oceanus-64.webp",
      "file128": "gods/oceanus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/minor_gods/oceanus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/oceanus-portrait",
      "file": "gods/oceanus-portrait-64.webp",
      "file128": "gods/oceanus-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/minor_gods/oceanus_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/odin",
      "file": "gods/odin-64.webp",
      "file128": "gods/odin-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/major_gods/odin_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/odin-portrait",
      "file": "gods/odin-portrait-64.webp",
      "file128": "gods/odin-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/major_gods/odin_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/oranos",
      "file": "gods/oranos-64.webp",
      "file128": "gods/oranos-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/major_gods/oranos_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/oranos-portrait",
      "file": "gods/oranos-portrait-64.webp",
      "file128": "gods/oranos-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/major_gods/oranos_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/osiris",
      "file": "gods/osiris-64.webp",
      "file128": "gods/osiris-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/minor_gods/osiris_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/osiris-portrait",
      "file": "gods/osiris-portrait-64.webp",
      "file128": "gods/osiris-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/minor_gods/osiris_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/poseidon",
      "file": "gods/poseidon-64.webp",
      "file128": "gods/poseidon-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/major_gods/poseidon_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/poseidon-portrait",
      "file": "gods/poseidon-portrait-64.webp",
      "file128": "gods/poseidon-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/major_gods/poseidon_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/prometheus",
      "file": "gods/prometheus-64.webp",
      "file128": "gods/prometheus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/minor_gods/prometheus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/prometheus-portrait",
      "file": "gods/prometheus-portrait-64.webp",
      "file128": "gods/prometheus-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/minor_gods/prometheus_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/ptah",
      "file": "gods/ptah-64.webp",
      "file128": "gods/ptah-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/minor_gods/ptah_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/ptah-portrait",
      "file": "gods/ptah-portrait-64.webp",
      "file128": "gods/ptah-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/minor_gods/ptah_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/ra",
      "file": "gods/ra-64.webp",
      "file128": "gods/ra-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/major_gods/ra_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/ra-portrait",
      "file": "gods/ra-portrait-64.webp",
      "file128": "gods/ra-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/major_gods/ra_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/rheia",
      "file": "gods/rheia-64.webp",
      "file128": "gods/rheia-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/minor_gods/rheia_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/rheia-portrait",
      "file": "gods/rheia-portrait-64.webp",
      "file128": "gods/rheia-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/minor_gods/rheia_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/sekhmet",
      "file": "gods/sekhmet-64.webp",
      "file128": "gods/sekhmet-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/minor_gods/sekhmet_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/sekhmet-portrait",
      "file": "gods/sekhmet-portrait-64.webp",
      "file128": "gods/sekhmet-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/minor_gods/sekhmet_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/set",
      "file": "gods/set-64.webp",
      "file128": "gods/set-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/major_gods/set_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/set-portrait",
      "file": "gods/set-portrait-64.webp",
      "file128": "gods/set-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/major_gods/set_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/skadi",
      "file": "gods/skadi-64.webp",
      "file128": "gods/skadi-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/minor_gods/skadi_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/skadi-portrait",
      "file": "gods/skadi-portrait-64.webp",
      "file128": "gods/skadi-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/minor_gods/skadi_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/sobek",
      "file": "gods/sobek-64.webp",
      "file128": "gods/sobek-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/minor_gods/sobek_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/sobek-portrait",
      "file": "gods/sobek-portrait-64.webp",
      "file128": "gods/sobek-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/minor_gods/sobek_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/theia",
      "file": "gods/theia-64.webp",
      "file128": "gods/theia-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/minor_gods/theia_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/theia-portrait",
      "file": "gods/theia-portrait-64.webp",
      "file128": "gods/theia-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/minor_gods/theia_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/thor",
      "file": "gods/thor-64.webp",
      "file128": "gods/thor-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/major_gods/thor_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/thor-portrait",
      "file": "gods/thor-portrait-64.webp",
      "file128": "gods/thor-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/major_gods/thor_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/thoth",
      "file": "gods/thoth-64.webp",
      "file128": "gods/thoth-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/minor_gods/thoth_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/thoth-portrait",
      "file": "gods/thoth-portrait-64.webp",
      "file128": "gods/thoth-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/minor_gods/thoth_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/tyr",
      "file": "gods/tyr-64.webp",
      "file128": "gods/tyr-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/minor_gods/tyr_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/tyr-portrait",
      "file": "gods/tyr-portrait-64.webp",
      "file128": "gods/tyr-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/minor_gods/tyr_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/zeus",
      "file": "gods/zeus-64.webp",
      "file128": "gods/zeus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/major_gods/zeus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "gods/zeus-portrait",
      "file": "gods/zeus-portrait-64.webp",
      "file128": "gods/zeus-portrait-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/major_gods/zeus_portrait.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/ancestors",
      "file": "powers/ancestors-64.webp",
      "file128": "powers/ancestors-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/god_powers/ancestors_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/bolt",
      "file": "powers/bolt-64.webp",
      "file128": "powers/bolt-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/god_powers/bolt_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/bronze",
      "file": "powers/bronze-64.webp",
      "file128": "powers/bronze-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/god_powers/bronze_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/carnivora",
      "file": "powers/carnivora-64.webp",
      "file128": "powers/carnivora-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/god_powers/carnivora_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/ceasefire",
      "file": "powers/ceasefire-64.webp",
      "file128": "powers/ceasefire-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/god_powers/ceasefire_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/chaos",
      "file": "powers/chaos-64.webp",
      "file128": "powers/chaos-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/god_powers/chaos_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/citadel",
      "file": "powers/citadel-64.webp",
      "file128": "powers/citadel-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/god_powers/citadel_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/curse",
      "file": "powers/curse-64.webp",
      "file128": "powers/curse-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/god_powers/curse_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/deconstruction",
      "file": "powers/deconstruction-64.webp",
      "file128": "powers/deconstruction-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/god_powers/deconstruction_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/dwarven-mine",
      "file": "powers/dwarven-mine-64.webp",
      "file128": "powers/dwarven-mine-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/god_powers/dwarven_mine_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/earthquake",
      "file": "powers/earthquake-64.webp",
      "file128": "powers/earthquake-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/god_powers/earthquake_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/eclipse",
      "file": "powers/eclipse-64.webp",
      "file128": "powers/eclipse-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/god_powers/eclipse_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/fimbulwinter",
      "file": "powers/fimbulwinter-64.webp",
      "file128": "powers/fimbulwinter-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/god_powers/fimbulwinter_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/flaming-weapons",
      "file": "powers/flaming-weapons-64.webp",
      "file128": "powers/flaming-weapons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/god_powers/flaming_weapons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/forest-fire",
      "file": "powers/forest-fire-64.webp",
      "file128": "powers/forest-fire-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/god_powers/forest_fire_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/frost",
      "file": "powers/frost-64.webp",
      "file128": "powers/frost-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/god_powers/frost_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/gaia-forest",
      "file": "powers/gaia-forest-64.webp",
      "file128": "powers/gaia-forest-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/god_powers/gaia_forest_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/great-hunt",
      "file": "powers/great-hunt-64.webp",
      "file128": "powers/great-hunt-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/god_powers/great_hunt_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/healing-spring",
      "file": "powers/healing-spring-64.webp",
      "file128": "powers/healing-spring-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/god_powers/healing_spring_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/hesperides",
      "file": "powers/hesperides-64.webp",
      "file128": "powers/hesperides-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/god_powers/hesperides_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/implode",
      "file": "powers/implode-64.webp",
      "file128": "powers/implode-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/god_powers/implode_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/lightning-storm",
      "file": "powers/lightning-storm-64.webp",
      "file128": "powers/lightning-storm-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/god_powers/lightning_storm_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/locust-swarm",
      "file": "powers/locust-swarm-64.webp",
      "file128": "powers/locust-swarm-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/god_powers/locust_swarm_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/lure",
      "file": "powers/lure-64.webp",
      "file128": "powers/lure-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/god_powers/lure_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/meteor",
      "file": "powers/meteor-64.webp",
      "file128": "powers/meteor-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/god_powers/meteor_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/nidhogg",
      "file": "powers/nidhogg-64.webp",
      "file128": "powers/nidhogg-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/god_powers/nidhogg_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/pestilence",
      "file": "powers/pestilence-64.webp",
      "file128": "powers/pestilence-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/god_powers/pestilence_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/plague-of-serpents",
      "file": "powers/plague-of-serpents-64.webp",
      "file128": "powers/plague-of-serpents-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/god_powers/plague_of_serpents_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/plenty",
      "file": "powers/plenty-64.webp",
      "file128": "powers/plenty-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/god_powers/plenty_vault_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/prosperity",
      "file": "powers/prosperity-64.webp",
      "file128": "powers/prosperity-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/god_powers/prosperity_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/ragnarok",
      "file": "powers/ragnarok-64.webp",
      "file128": "powers/ragnarok-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/god_powers/ragnarok_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/rain",
      "file": "powers/rain-64.webp",
      "file128": "powers/rain-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/god_powers/rain_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/restoration",
      "file": "powers/restoration-64.webp",
      "file128": "powers/restoration-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/god_powers/restoration_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/sentinel",
      "file": "powers/sentinel-64.webp",
      "file128": "powers/sentinel-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/god_powers/sentinel_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/shifting-sands",
      "file": "powers/shifting-sands-64.webp",
      "file128": "powers/shifting-sands-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/god_powers/shifting_sands_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/shockwave",
      "file": "powers/shockwave-64.webp",
      "file128": "powers/shockwave-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/god_powers/shockwave_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/son-of-osiris",
      "file": "powers/son-of-osiris-64.webp",
      "file128": "powers/son-of-osiris-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/god_powers/son_of_osiris_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/spider-lair",
      "file": "powers/spider-lair-64.webp",
      "file128": "powers/spider-lair-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/god_powers/spider_lair_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/spy",
      "file": "powers/spy-64.webp",
      "file128": "powers/spy-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/god_powers/spy_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/tartarian-gate",
      "file": "powers/tartarian-gate-64.webp",
      "file128": "powers/tartarian-gate-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/god_powers/tartarian_gate_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/time-shift",
      "file": "powers/time-shift-64.webp",
      "file128": "powers/time-shift-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/abilities/time_shift_ability_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/tornado",
      "file": "powers/tornado-64.webp",
      "file128": "powers/tornado-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/god_powers/tornado_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/traitor",
      "file": "powers/traitor-64.webp",
      "file128": "powers/traitor-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/god_powers/traitor_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/undermine",
      "file": "powers/undermine-64.webp",
      "file128": "powers/undermine-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/god_powers/undermine_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/underworld-passage",
      "file": "powers/underworld-passage-64.webp",
      "file128": "powers/underworld-passage-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/god_powers/underworld_passage_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/valor",
      "file": "powers/valor-64.webp",
      "file128": "powers/valor-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/god_powers/valor_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/vision",
      "file": "powers/vision-64.webp",
      "file128": "powers/vision-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/god_powers/vision_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/vortex",
      "file": "powers/vortex-64.webp",
      "file128": "powers/vortex-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/god_powers/vortex_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "powers/walking-woods",
      "file": "powers/walking-woods-64.webp",
      "file128": "powers/walking-woods-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/god_powers/walking_woods_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "resources/favor",
      "file": "resources/favor-64.webp",
      "file128": "resources/favor-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/in_game/res_favor_large.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "resources/food",
      "file": "resources/food-64.webp",
      "file128": "resources/food-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/in_game/res_food_large.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "resources/gold",
      "file": "resources/gold-64.webp",
      "file128": "resources/gold-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/in_game/res_gold_large.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "resources/source-berries",
      "file": "resources/source-berries-64.webp",
      "file128": "resources/source-berries-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/nature/berry_bush_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "resources/source-farm",
      "file": "resources/source-farm-64.webp",
      "file128": "resources/source-farm-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/buildings/farm_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "resources/source-fish",
      "file": "resources/source-fish-64.webp",
      "file128": "resources/source-fish-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/nature/animals/naval/fish_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "resources/source-gold",
      "file": "resources/source-gold-64.webp",
      "file128": "resources/source-gold-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/nature/mines/gold_mine_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "resources/source-herd",
      "file": "resources/source-herd-64.webp",
      "file128": "resources/source-herd-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/nature/animals/land/goat_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "resources/source-hunt",
      "file": "resources/source-hunt-64.webp",
      "file128": "resources/source-hunt-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/nature/animals/land/deer_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "resources/source-wood",
      "file": "resources/source-wood-64.webp",
      "file128": "resources/source-wood-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/nature/trees/tree_oak_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "resources/wood",
      "file": "resources/wood-64.webp",
      "file128": "resources/wood-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/in_game/res_wood_large.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-advanced-fortifications",
      "file": "techs/atlanteans-advanced-fortifications-64.webp",
      "file128": "techs/atlanteans-advanced-fortifications-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/advanced_fortifications_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-alluvial-clay",
      "file": "techs/atlanteans-alluvial-clay-64.webp",
      "file128": "techs/atlanteans-alluvial-clay-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/alluvial_clay_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-ambassadors",
      "file": "techs/atlanteans-ambassadors-64.webp",
      "file128": "techs/atlanteans-ambassadors-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/ambassadors_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-architects",
      "file": "techs/atlanteans-architects-64.webp",
      "file128": "techs/atlanteans-architects-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/architects_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-asper-blood",
      "file": "techs/atlanteans-asper-blood-64.webp",
      "file128": "techs/atlanteans-asper-blood-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/asper_blood_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-ballistics",
      "file": "techs/atlanteans-ballistics-64.webp",
      "file128": "techs/atlanteans-ballistics-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/ballistics_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-bite-of-the-shark",
      "file": "techs/atlanteans-bite-of-the-shark-64.webp",
      "file128": "techs/atlanteans-bite-of-the-shark-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/bite_of_the_shark_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-bow-saw",
      "file": "techs/atlanteans-bow-saw-64.webp",
      "file128": "techs/atlanteans-bow-saw-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/bow_saw_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-bow-saw-gaia",
      "file": "techs/atlanteans-bow-saw-gaia-64.webp",
      "file128": "techs/atlanteans-bow-saw-gaia-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/bow_saw_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-bronze-armor",
      "file": "techs/atlanteans-bronze-armor-64.webp",
      "file128": "techs/atlanteans-bronze-armor-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/bronze_armor_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-bronze-shields",
      "file": "techs/atlanteans-bronze-shields-64.webp",
      "file128": "techs/atlanteans-bronze-shields-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/bronze_shields_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-bronze-weapons",
      "file": "techs/atlanteans-bronze-weapons-64.webp",
      "file128": "techs/atlanteans-bronze-weapons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/bronze_weapons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-burning-pitch",
      "file": "techs/atlanteans-burning-pitch-64.webp",
      "file128": "techs/atlanteans-burning-pitch-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/burning_pitch_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-carpenters",
      "file": "techs/atlanteans-carpenters-64.webp",
      "file128": "techs/atlanteans-carpenters-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/carpenters_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-carpenters-gaia",
      "file": "techs/atlanteans-carpenters-gaia-64.webp",
      "file128": "techs/atlanteans-carpenters-gaia-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/carpenters_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-celerity",
      "file": "techs/atlanteans-celerity-64.webp",
      "file128": "techs/atlanteans-celerity-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/celerity_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-champion-cavalry",
      "file": "techs/atlanteans-champion-cavalry-64.webp",
      "file128": "techs/atlanteans-champion-cavalry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/champion_cavalry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-champion-infantry",
      "file": "techs/atlanteans-champion-infantry-64.webp",
      "file128": "techs/atlanteans-champion-infantry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/champion_infantry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-champion-ranged-soldiers",
      "file": "techs/atlanteans-champion-ranged-soldiers-64.webp",
      "file128": "techs/atlanteans-champion-ranged-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/champion_archers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-champion-warships",
      "file": "techs/atlanteans-champion-warships-64.webp",
      "file128": "techs/atlanteans-champion-warships-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/champion_warships_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-channels",
      "file": "techs/atlanteans-channels-64.webp",
      "file128": "techs/atlanteans-channels-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/channels_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-coinage",
      "file": "techs/atlanteans-coinage-64.webp",
      "file128": "techs/atlanteans-coinage-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/coinage_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-conscript-counter-soldiers",
      "file": "techs/atlanteans-conscript-counter-soldiers-64.webp",
      "file128": "techs/atlanteans-conscript-counter-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/conscript_counter_soldiers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-conscript-mainline-soldiers",
      "file": "techs/atlanteans-conscript-mainline-soldiers-64.webp",
      "file128": "techs/atlanteans-conscript-mainline-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/conscript_mainline_soldiers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-conscript-palace-soldiers",
      "file": "techs/atlanteans-conscript-palace-soldiers-64.webp",
      "file128": "techs/atlanteans-conscript-palace-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/conscript_palace_soldiers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-conscript-sailors",
      "file": "techs/atlanteans-conscript-sailors-64.webp",
      "file128": "techs/atlanteans-conscript-sailors-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/conscript_sailors_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-copper-armor",
      "file": "techs/atlanteans-copper-armor-64.webp",
      "file128": "techs/atlanteans-copper-armor-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/copper_armor_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-copper-shields",
      "file": "techs/atlanteans-copper-shields-64.webp",
      "file128": "techs/atlanteans-copper-shields-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/copper_shields_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-copper-weapons",
      "file": "techs/atlanteans-copper-weapons-64.webp",
      "file128": "techs/atlanteans-copper-weapons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/copper_weapons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-daktyloi",
      "file": "techs/atlanteans-daktyloi-64.webp",
      "file128": "techs/atlanteans-daktyloi-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/daktyloi_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-daughters-of-the-sea",
      "file": "techs/atlanteans-daughters-of-the-sea-64.webp",
      "file128": "techs/atlanteans-daughters-of-the-sea-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/daughters_of_the_sea_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-devotees-of-atlas",
      "file": "techs/atlanteans-devotees-of-atlas-64.webp",
      "file128": "techs/atlanteans-devotees-of-atlas-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/devotees_of_atlas_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-draft-horses",
      "file": "techs/atlanteans-draft-horses-64.webp",
      "file128": "techs/atlanteans-draft-horses-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/draft_horses_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-empyrian-speed",
      "file": "techs/atlanteans-empyrian-speed-64.webp",
      "file128": "techs/atlanteans-empyrian-speed-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache.bar/resources/atlantean/static_color/technologies/empyrean_speed_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-enclosed-deck",
      "file": "techs/atlanteans-enclosed-deck-64.webp",
      "file128": "techs/atlanteans-enclosed-deck-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/enclosed_deck_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-engineers",
      "file": "techs/atlanteans-engineers-64.webp",
      "file128": "techs/atlanteans-engineers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/engineers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-flood-control",
      "file": "techs/atlanteans-flood-control-64.webp",
      "file128": "techs/atlanteans-flood-control-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/flood_control_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-flood-control-gaia",
      "file": "techs/atlanteans-flood-control-gaia-64.webp",
      "file128": "techs/atlanteans-flood-control-gaia-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/flood_control_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-fortified-town-center",
      "file": "techs/atlanteans-fortified-town-center-64.webp",
      "file128": "techs/atlanteans-fortified-town-center-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/fortified_town_center_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-frontline-heroics",
      "file": "techs/atlanteans-frontline-heroics-64.webp",
      "file128": "techs/atlanteans-frontline-heroics-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/frontline_heroics_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-gemini",
      "file": "techs/atlanteans-gemini-64.webp",
      "file128": "techs/atlanteans-gemini-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/gemini_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-guardian-of-io",
      "file": "techs/atlanteans-guardian-of-io-64.webp",
      "file128": "techs/atlanteans-guardian-of-io-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/guardian_of_io_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-halo-of-the-sun",
      "file": "techs/atlanteans-halo-of-the-sun-64.webp",
      "file128": "techs/atlanteans-halo-of-the-sun-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/halo_of_the_sun_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-hand-axe",
      "file": "techs/atlanteans-hand-axe-64.webp",
      "file128": "techs/atlanteans-hand-axe-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/hand_axe_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-heart-of-the-titans",
      "file": "techs/atlanteans-heart-of-the-titans-64.webp",
      "file128": "techs/atlanteans-heart-of-the-titans-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/heart_of_the_titans_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-heavy-cavalry",
      "file": "techs/atlanteans-heavy-cavalry-64.webp",
      "file128": "techs/atlanteans-heavy-cavalry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/heavy_cavalry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-heavy-infantry",
      "file": "techs/atlanteans-heavy-infantry-64.webp",
      "file128": "techs/atlanteans-heavy-infantry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/heavy_infantry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-heavy-ranged-soldiers",
      "file": "techs/atlanteans-heavy-ranged-soldiers-64.webp",
      "file128": "techs/atlanteans-heavy-ranged-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/heavy_archers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-heavy-warships",
      "file": "techs/atlanteans-heavy-warships-64.webp",
      "file128": "techs/atlanteans-heavy-warships-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/heavy_warships_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-hephaestus-revenge",
      "file": "techs/atlanteans-hephaestus-revenge-64.webp",
      "file128": "techs/atlanteans-hephaestus-revenge-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/hephaestus_revenge_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-heroic-fleet",
      "file": "techs/atlanteans-heroic-fleet-64.webp",
      "file128": "techs/atlanteans-heroic-fleet-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/heroic_fleet_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-heroic-renewal",
      "file": "techs/atlanteans-heroic-renewal-64.webp",
      "file128": "techs/atlanteans-heroic-renewal-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/heroic_renewal_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-horns-of-consecration",
      "file": "techs/atlanteans-horns-of-consecration-64.webp",
      "file128": "techs/atlanteans-horns-of-consecration-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/horns_of_consecration_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-husbandry",
      "file": "techs/atlanteans-husbandry-64.webp",
      "file128": "techs/atlanteans-husbandry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/husbandry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-iron-armor",
      "file": "techs/atlanteans-iron-armor-64.webp",
      "file128": "techs/atlanteans-iron-armor-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/iron_armor_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-iron-shields",
      "file": "techs/atlanteans-iron-shields-64.webp",
      "file128": "techs/atlanteans-iron-shields-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/iron_shields_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-iron-weapons",
      "file": "techs/atlanteans-iron-weapons-64.webp",
      "file128": "techs/atlanteans-iron-weapons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/iron_weapons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-irrigation",
      "file": "techs/atlanteans-irrigation-64.webp",
      "file128": "techs/atlanteans-irrigation-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/irrigation_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-irrigation-gaia",
      "file": "techs/atlanteans-irrigation-gaia-64.webp",
      "file128": "techs/atlanteans-irrigation-gaia-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/irrigation_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-lance-of-stone",
      "file": "techs/atlanteans-lance-of-stone-64.webp",
      "file128": "techs/atlanteans-lance-of-stone-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/lance_of_stone_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-levy-counter-soldiers",
      "file": "techs/atlanteans-levy-counter-soldiers-64.webp",
      "file128": "techs/atlanteans-levy-counter-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/levy_counter_soldiers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-levy-mainline-soldiers",
      "file": "techs/atlanteans-levy-mainline-soldiers-64.webp",
      "file128": "techs/atlanteans-levy-mainline-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/levy_mainline_soldiers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-levy-palace-soldiers",
      "file": "techs/atlanteans-levy-palace-soldiers-64.webp",
      "file128": "techs/atlanteans-levy-palace-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/levy_palace_soldiers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-masons",
      "file": "techs/atlanteans-masons-64.webp",
      "file128": "techs/atlanteans-masons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/masons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-medium-infantry",
      "file": "techs/atlanteans-medium-infantry-64.webp",
      "file128": "techs/atlanteans-medium-infantry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/medium_infantry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-medium-ranged-soldiers",
      "file": "techs/atlanteans-medium-ranged-soldiers-64.webp",
      "file128": "techs/atlanteans-medium-ranged-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/medium_archers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-mythic-rejuvenation",
      "file": "techs/atlanteans-mythic-rejuvenation-64.webp",
      "file128": "techs/atlanteans-mythic-rejuvenation-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/mythic_rejuvenation_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-orichalcum-mail",
      "file": "techs/atlanteans-orichalcum-mail-64.webp",
      "file128": "techs/atlanteans-orichalcum-mail-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/orichalcum_mail_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-perception",
      "file": "techs/atlanteans-perception-64.webp",
      "file128": "techs/atlanteans-perception-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/perception_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-petrification",
      "file": "techs/atlanteans-petrification-64.webp",
      "file128": "techs/atlanteans-petrification-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/petrification_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-pickaxe",
      "file": "techs/atlanteans-pickaxe-64.webp",
      "file128": "techs/atlanteans-pickaxe-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/pickaxe_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-pioneer-of-the-skies",
      "file": "techs/atlanteans-pioneer-of-the-skies-64.webp",
      "file128": "techs/atlanteans-pioneer-of-the-skies-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/pioneer_of_the_skies_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-plow",
      "file": "techs/atlanteans-plow-64.webp",
      "file128": "techs/atlanteans-plow-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/plow_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-plow-gaia",
      "file": "techs/atlanteans-plow-gaia-64.webp",
      "file128": "techs/atlanteans-plow-gaia-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/plow_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-poseidons-secret",
      "file": "techs/atlanteans-poseidons-secret-64.webp",
      "file128": "techs/atlanteans-poseidons-secret-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/poseidons_secret_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-prophetic-sight",
      "file": "techs/atlanteans-prophetic-sight-64.webp",
      "file128": "techs/atlanteans-prophetic-sight-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/prophetic_sight_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-purse-seine",
      "file": "techs/atlanteans-purse-seine-64.webp",
      "file128": "techs/atlanteans-purse-seine-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/purse_seine_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-quarry",
      "file": "techs/atlanteans-quarry-64.webp",
      "file128": "techs/atlanteans-quarry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/quarry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-quarry-gaia",
      "file": "techs/atlanteans-quarry-gaia-64.webp",
      "file128": "techs/atlanteans-quarry-gaia-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/quarry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-rheias-gift",
      "file": "techs/atlanteans-rheias-gift-64.webp",
      "file128": "techs/atlanteans-rheias-gift-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/rheias_gift_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-salt-amphora",
      "file": "techs/atlanteans-salt-amphora-64.webp",
      "file128": "techs/atlanteans-salt-amphora-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/salt_amphora_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-shaft-mine",
      "file": "techs/atlanteans-shaft-mine-64.webp",
      "file128": "techs/atlanteans-shaft-mine-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/shaft_mine_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-shaft-mine-gaia",
      "file": "techs/atlanteans-shaft-mine-gaia-64.webp",
      "file128": "techs/atlanteans-shaft-mine-gaia-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/shaft_mine_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-sons-of-the-sun",
      "file": "techs/atlanteans-sons-of-the-sun-64.webp",
      "file128": "techs/atlanteans-sons-of-the-sun-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/sons_of_the_sun_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-survival-equipment",
      "file": "techs/atlanteans-survival-equipment-64.webp",
      "file128": "techs/atlanteans-survival-equipment-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/hunting_equipment_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-survival-equipment-gaia",
      "file": "techs/atlanteans-survival-equipment-gaia-64.webp",
      "file128": "techs/atlanteans-survival-equipment-gaia-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/hunting_equipment_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-tax-collectors",
      "file": "techs/atlanteans-tax-collectors-64.webp",
      "file128": "techs/atlanteans-tax-collectors-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/tax_collectors_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-temporal-chaos",
      "file": "techs/atlanteans-temporal-chaos-64.webp",
      "file128": "techs/atlanteans-temporal-chaos-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/temporal_chaos_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-theft-of-fire",
      "file": "techs/atlanteans-theft-of-fire-64.webp",
      "file128": "techs/atlanteans-theft-of-fire-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/theft_of_fire_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-titan-shield",
      "file": "techs/atlanteans-titan-shield-64.webp",
      "file128": "techs/atlanteans-titan-shield-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/titan_shield_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-titanomachy",
      "file": "techs/atlanteans-titanomachy-64.webp",
      "file128": "techs/atlanteans-titanomachy-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/titanomachy_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-volcanic-forge",
      "file": "techs/atlanteans-volcanic-forge-64.webp",
      "file128": "techs/atlanteans-volcanic-forge-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/volcanic_forge_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/atlanteans-weightless-mace",
      "file": "techs/atlanteans-weightless-mace-64.webp",
      "file128": "techs/atlanteans-weightless-mace-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/weightless_mace_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-advanced-fortifications",
      "file": "techs/egyptians-advanced-fortifications-64.webp",
      "file128": "techs/egyptians-advanced-fortifications-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/advanced_fortifications_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-adze-of-wepwawet",
      "file": "techs/egyptians-adze-of-wepwawet-64.webp",
      "file128": "techs/egyptians-adze-of-wepwawet-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/adze_of_wepwawet_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-ambassadors",
      "file": "techs/egyptians-ambassadors-64.webp",
      "file128": "techs/egyptians-ambassadors-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/ambassadors_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-architects",
      "file": "techs/egyptians-architects-64.webp",
      "file128": "techs/egyptians-architects-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/architects_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-atef-crown",
      "file": "techs/egyptians-atef-crown-64.webp",
      "file128": "techs/egyptians-atef-crown-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/atef_crown_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-axe-of-vengeance",
      "file": "techs/egyptians-axe-of-vengeance-64.webp",
      "file128": "techs/egyptians-axe-of-vengeance-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/axe_of_vengeance_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-ballista-tower",
      "file": "techs/egyptians-ballista-tower-64.webp",
      "file128": "techs/egyptians-ballista-tower-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/ballista_tower_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-ballistics",
      "file": "techs/egyptians-ballistics-64.webp",
      "file128": "techs/egyptians-ballistics-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/ballistics_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-boiling-oil",
      "file": "techs/egyptians-boiling-oil-64.webp",
      "file128": "techs/egyptians-boiling-oil-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/boiling_oil_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-bone-bow",
      "file": "techs/egyptians-bone-bow-64.webp",
      "file128": "techs/egyptians-bone-bow-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/bone_bow_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-book-of-thoth",
      "file": "techs/egyptians-book-of-thoth-64.webp",
      "file128": "techs/egyptians-book-of-thoth-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/book_of_thoth_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-bow-saw",
      "file": "techs/egyptians-bow-saw-64.webp",
      "file128": "techs/egyptians-bow-saw-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/bow_saw_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-bronze-armor",
      "file": "techs/egyptians-bronze-armor-64.webp",
      "file128": "techs/egyptians-bronze-armor-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/bronze_armor_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-bronze-shields",
      "file": "techs/egyptians-bronze-shields-64.webp",
      "file128": "techs/egyptians-bronze-shields-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/bronze_shields_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-bronze-weapons",
      "file": "techs/egyptians-bronze-weapons-64.webp",
      "file128": "techs/egyptians-bronze-weapons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/bronze_weapons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-burning-pitch",
      "file": "techs/egyptians-burning-pitch-64.webp",
      "file128": "techs/egyptians-burning-pitch-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/burning_pitch_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-carpenters",
      "file": "techs/egyptians-carpenters-64.webp",
      "file128": "techs/egyptians-carpenters-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/carpenters_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-carrier-pigeons",
      "file": "techs/egyptians-carrier-pigeons-64.webp",
      "file128": "techs/egyptians-carrier-pigeons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/carrier_pigeons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-champion-axemen",
      "file": "techs/egyptians-champion-axemen-64.webp",
      "file128": "techs/egyptians-champion-axemen-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/champion_axemen_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-champion-camel-riders",
      "file": "techs/egyptians-champion-camel-riders-64.webp",
      "file128": "techs/egyptians-champion-camel-riders-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/champion_camel_riders_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-champion-chariots",
      "file": "techs/egyptians-champion-chariots-64.webp",
      "file128": "techs/egyptians-champion-chariots-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/champion_chariot_archers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-champion-slingers",
      "file": "techs/egyptians-champion-slingers-64.webp",
      "file128": "techs/egyptians-champion-slingers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/champion_slingers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-champion-spearmen",
      "file": "techs/egyptians-champion-spearmen-64.webp",
      "file128": "techs/egyptians-champion-spearmen-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/champion_spearmen_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-champion-war-elephants",
      "file": "techs/egyptians-champion-war-elephants-64.webp",
      "file128": "techs/egyptians-champion-war-elephants-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/champion_war_elephants_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-champion-warships",
      "file": "techs/egyptians-champion-warships-64.webp",
      "file128": "techs/egyptians-champion-warships-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/champion_warships_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-citadel-wall",
      "file": "techs/egyptians-citadel-wall-64.webp",
      "file128": "techs/egyptians-citadel-wall-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/citadel_wall_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-clairvoyance",
      "file": "techs/egyptians-clairvoyance-64.webp",
      "file128": "techs/egyptians-clairvoyance-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/clairvoyance_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-coinage",
      "file": "techs/egyptians-coinage-64.webp",
      "file128": "techs/egyptians-coinage-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/coinage_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-conscript-barracks-soldiers",
      "file": "techs/egyptians-conscript-barracks-soldiers-64.webp",
      "file128": "techs/egyptians-conscript-barracks-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/conscript_barracks_soldiers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-conscript-migdol-soldiers",
      "file": "techs/egyptians-conscript-migdol-soldiers-64.webp",
      "file128": "techs/egyptians-conscript-migdol-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/conscript_migdol_soldiers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-conscript-sailors",
      "file": "techs/egyptians-conscript-sailors-64.webp",
      "file128": "techs/egyptians-conscript-sailors-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/conscript_sailors_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-copper-armor",
      "file": "techs/egyptians-copper-armor-64.webp",
      "file128": "techs/egyptians-copper-armor-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/copper_armor_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-copper-shields",
      "file": "techs/egyptians-copper-shields-64.webp",
      "file128": "techs/egyptians-copper-shields-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/copper_shields_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-copper-weapons",
      "file": "techs/egyptians-copper-weapons-64.webp",
      "file128": "techs/egyptians-copper-weapons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/copper_weapons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-crenellations",
      "file": "techs/egyptians-crenellations-64.webp",
      "file128": "techs/egyptians-crenellations-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/crenellations_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-crimson-linen",
      "file": "techs/egyptians-crimson-linen-64.webp",
      "file128": "techs/egyptians-crimson-linen-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/crimson_linen_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-criosphinx",
      "file": "techs/egyptians-criosphinx-64.webp",
      "file128": "techs/egyptians-criosphinx-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/criosphinx_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-crocodilopolis",
      "file": "techs/egyptians-crocodilopolis-64.webp",
      "file128": "techs/egyptians-crocodilopolis-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/crocodilopolis_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-dark-water",
      "file": "techs/egyptians-dark-water-64.webp",
      "file128": "techs/egyptians-dark-water-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache.bar/resources/egyptian/static_color/technologies/dark_water_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-desert-wind",
      "file": "techs/egyptians-desert-wind-64.webp",
      "file128": "techs/egyptians-desert-wind-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/desert_wind_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-draft-horses",
      "file": "techs/egyptians-draft-horses-64.webp",
      "file128": "techs/egyptians-draft-horses-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/draft_horses_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-electrum-bullets",
      "file": "techs/egyptians-electrum-bullets-64.webp",
      "file128": "techs/egyptians-electrum-bullets-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/electrum_bullets_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-enclosed-deck",
      "file": "techs/egyptians-enclosed-deck-64.webp",
      "file128": "techs/egyptians-enclosed-deck-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/enclosed_deck_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-engineers",
      "file": "techs/egyptians-engineers-64.webp",
      "file128": "techs/egyptians-engineers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/engineers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-feet-of-the-jackal",
      "file": "techs/egyptians-feet-of-the-jackal-64.webp",
      "file128": "techs/egyptians-feet-of-the-jackal-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/feet_of_the_jackal_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-flood-control",
      "file": "techs/egyptians-flood-control-64.webp",
      "file128": "techs/egyptians-flood-control-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/flood_control_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-flood-of-the-nile",
      "file": "techs/egyptians-flood-of-the-nile-64.webp",
      "file128": "techs/egyptians-flood-of-the-nile-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/flood_of_the_nile_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-force-of-the-west-wind",
      "file": "techs/egyptians-force-of-the-west-wind-64.webp",
      "file128": "techs/egyptians-force-of-the-west-wind-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/force_of_the_west_wind_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-fortified-town-center",
      "file": "techs/egyptians-fortified-town-center-64.webp",
      "file128": "techs/egyptians-fortified-town-center-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/fortified_town_center_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-fortified-wall",
      "file": "techs/egyptians-fortified-wall-64.webp",
      "file128": "techs/egyptians-fortified-wall-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/fortified_wall_egyptian_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-funeral-barge",
      "file": "techs/egyptians-funeral-barge-64.webp",
      "file128": "techs/egyptians-funeral-barge-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/funeral_barge_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-funeral-rites",
      "file": "techs/egyptians-funeral-rites-64.webp",
      "file128": "techs/egyptians-funeral-rites-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/funeral_rites_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-greatest-of-fifty",
      "file": "techs/egyptians-greatest-of-fifty-64.webp",
      "file128": "techs/egyptians-greatest-of-fifty-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/greatest_of_fifty_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-guard-tower",
      "file": "techs/egyptians-guard-tower-64.webp",
      "file128": "techs/egyptians-guard-tower-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/guard_tower_egyptian_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-hand-axe",
      "file": "techs/egyptians-hand-axe-64.webp",
      "file128": "techs/egyptians-hand-axe-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/hand_axe_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-hands-of-the-pharaoh",
      "file": "techs/egyptians-hands-of-the-pharaoh-64.webp",
      "file128": "techs/egyptians-hands-of-the-pharaoh-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/hands_of_the_pharaoh_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-heavy-axemen",
      "file": "techs/egyptians-heavy-axemen-64.webp",
      "file128": "techs/egyptians-heavy-axemen-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/heavy_axemen_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-heavy-camel-riders",
      "file": "techs/egyptians-heavy-camel-riders-64.webp",
      "file128": "techs/egyptians-heavy-camel-riders-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/heavy_camel_riders_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-heavy-chariots",
      "file": "techs/egyptians-heavy-chariots-64.webp",
      "file128": "techs/egyptians-heavy-chariots-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/heavy_chariot_archers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-heavy-slingers",
      "file": "techs/egyptians-heavy-slingers-64.webp",
      "file128": "techs/egyptians-heavy-slingers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/heavy_slingers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-heavy-spearmen",
      "file": "techs/egyptians-heavy-spearmen-64.webp",
      "file128": "techs/egyptians-heavy-spearmen-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/heavy_spearmen_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-heavy-war-elephants",
      "file": "techs/egyptians-heavy-war-elephants-64.webp",
      "file128": "techs/egyptians-heavy-war-elephants-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/heavy_war_elephants_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-heavy-warships",
      "file": "techs/egyptians-heavy-warships-64.webp",
      "file128": "techs/egyptians-heavy-warships-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/heavy_warships_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-heroic-fleet",
      "file": "techs/egyptians-heroic-fleet-64.webp",
      "file128": "techs/egyptians-heroic-fleet-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/heroic_fleet_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-hieracosphinx",
      "file": "techs/egyptians-hieracosphinx-64.webp",
      "file128": "techs/egyptians-hieracosphinx-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/hieracosphinx_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-husbandry",
      "file": "techs/egyptians-husbandry-64.webp",
      "file128": "techs/egyptians-husbandry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/husbandry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-iron-armor",
      "file": "techs/egyptians-iron-armor-64.webp",
      "file128": "techs/egyptians-iron-armor-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/iron_armor_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-iron-shields",
      "file": "techs/egyptians-iron-shields-64.webp",
      "file128": "techs/egyptians-iron-shields-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/iron_shields_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-iron-weapons",
      "file": "techs/egyptians-iron-weapons-64.webp",
      "file128": "techs/egyptians-iron-weapons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/iron_weapons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-irrigation",
      "file": "techs/egyptians-irrigation-64.webp",
      "file128": "techs/egyptians-irrigation-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/irrigation_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-leather-frame-shield",
      "file": "techs/egyptians-leather-frame-shield-64.webp",
      "file128": "techs/egyptians-leather-frame-shield-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/leather_frame_shield_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-levy-barracks-soldiers",
      "file": "techs/egyptians-levy-barracks-soldiers-64.webp",
      "file128": "techs/egyptians-levy-barracks-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/levy_barracks_soldiers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-levy-migdol-soldiers",
      "file": "techs/egyptians-levy-migdol-soldiers-64.webp",
      "file128": "techs/egyptians-levy-migdol-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/levy_migdol_soldiers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-masons",
      "file": "techs/egyptians-masons-64.webp",
      "file128": "techs/egyptians-masons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/masons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-medium-axemen",
      "file": "techs/egyptians-medium-axemen-64.webp",
      "file128": "techs/egyptians-medium-axemen-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/medium_axemen_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-medium-slingers",
      "file": "techs/egyptians-medium-slingers-64.webp",
      "file128": "techs/egyptians-medium-slingers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/medium_slingers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-medium-spearmen",
      "file": "techs/egyptians-medium-spearmen-64.webp",
      "file128": "techs/egyptians-medium-spearmen-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/medium_spearmen_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-nebty",
      "file": "techs/egyptians-nebty-64.webp",
      "file128": "techs/egyptians-nebty-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/nebty_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-necropolis",
      "file": "techs/egyptians-necropolis-64.webp",
      "file128": "techs/egyptians-necropolis-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/necropolis_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-new-kingdom",
      "file": "techs/egyptians-new-kingdom-64.webp",
      "file128": "techs/egyptians-new-kingdom-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/new_kingdom_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-omniscience",
      "file": "techs/egyptians-omniscience-64.webp",
      "file128": "techs/egyptians-omniscience-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/omniscience_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-pickaxe",
      "file": "techs/egyptians-pickaxe-64.webp",
      "file128": "techs/egyptians-pickaxe-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/pickaxe_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-plow",
      "file": "techs/egyptians-plow-64.webp",
      "file128": "techs/egyptians-plow-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/plow_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-purse-seine",
      "file": "techs/egyptians-purse-seine-64.webp",
      "file128": "techs/egyptians-purse-seine-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/purse_seine_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-quarry",
      "file": "techs/egyptians-quarry-64.webp",
      "file128": "techs/egyptians-quarry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/quarry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-sacred-cats",
      "file": "techs/egyptians-sacred-cats-64.webp",
      "file128": "techs/egyptians-sacred-cats-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/sacred_cats_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-salt-amphora",
      "file": "techs/egyptians-salt-amphora-64.webp",
      "file128": "techs/egyptians-salt-amphora-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/salt_amphora_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-scalloped-axe",
      "file": "techs/egyptians-scalloped-axe-64.webp",
      "file128": "techs/egyptians-scalloped-axe-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/scalloped_axe_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-secrets-of-the-titans",
      "file": "techs/egyptians-secrets-of-the-titans-64.webp",
      "file128": "techs/egyptians-secrets-of-the-titans-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/secrets_of_the_titans_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-serpent-spear",
      "file": "techs/egyptians-serpent-spear-64.webp",
      "file128": "techs/egyptians-serpent-spear-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/serpent_spear_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-shaduf",
      "file": "techs/egyptians-shaduf-64.webp",
      "file128": "techs/egyptians-shaduf-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/shaduf_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-shaft-mine",
      "file": "techs/egyptians-shaft-mine-64.webp",
      "file128": "techs/egyptians-shaft-mine-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/shaft_mine_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-signal-fires",
      "file": "techs/egyptians-signal-fires-64.webp",
      "file128": "techs/egyptians-signal-fires-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/signal_fires_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-skin-of-the-rhino",
      "file": "techs/egyptians-skin-of-the-rhino-64.webp",
      "file128": "techs/egyptians-skin-of-the-rhino-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/skin_of_the_rhino_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-slings-of-the-sun",
      "file": "techs/egyptians-slings-of-the-sun-64.webp",
      "file128": "techs/egyptians-slings-of-the-sun-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/slings_of_the_sun_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-solar-barque",
      "file": "techs/egyptians-solar-barque-64.webp",
      "file128": "techs/egyptians-solar-barque-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/solar_barque_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-spear-of-horus",
      "file": "techs/egyptians-spear-of-horus-64.webp",
      "file128": "techs/egyptians-spear-of-horus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/spear_of_horus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-spirit-of-maat",
      "file": "techs/egyptians-spirit-of-maat-64.webp",
      "file128": "techs/egyptians-spirit-of-maat-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/spirit_of_maat_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-stone-wall",
      "file": "techs/egyptians-stone-wall-64.webp",
      "file128": "techs/egyptians-stone-wall-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/stone_wall_egyptian_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-sun-dried-mud-brick",
      "file": "techs/egyptians-sun-dried-mud-brick-64.webp",
      "file128": "techs/egyptians-sun-dried-mud-brick-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/sundried_mud_brick_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-survival-equipment",
      "file": "techs/egyptians-survival-equipment-64.webp",
      "file128": "techs/egyptians-survival-equipment-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/hunting_equipment_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-tax-collectors",
      "file": "techs/egyptians-tax-collectors-64.webp",
      "file128": "techs/egyptians-tax-collectors-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/tax_collectors_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-tusks-of-apedemak",
      "file": "techs/egyptians-tusks-of-apedemak-64.webp",
      "file128": "techs/egyptians-tusks-of-apedemak-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/tusks_of_apedemak_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-valley-of-the-kings",
      "file": "techs/egyptians-valley-of-the-kings-64.webp",
      "file128": "techs/egyptians-valley-of-the-kings-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/valley_of_the_kings_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/egyptians-watch-tower",
      "file": "techs/egyptians-watch-tower-64.webp",
      "file128": "techs/egyptians-watch-tower-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/technologies/watch_tower_egyptian_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-advanced-fortifications",
      "file": "techs/greeks-advanced-fortifications-64.webp",
      "file128": "techs/greeks-advanced-fortifications-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/advanced_fortifications_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-aegis-shield",
      "file": "techs/greeks-aegis-shield-64.webp",
      "file128": "techs/greeks-aegis-shield-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/aegis_shield_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-ambassadors",
      "file": "techs/greeks-ambassadors-64.webp",
      "file128": "techs/greeks-ambassadors-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/ambassadors_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-anastrophe",
      "file": "techs/greeks-anastrophe-64.webp",
      "file128": "techs/greeks-anastrophe-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/anastrophe_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-architects",
      "file": "techs/greeks-architects-64.webp",
      "file128": "techs/greeks-architects-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/architects_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-argive-patronage",
      "file": "techs/greeks-argive-patronage-64.webp",
      "file128": "techs/greeks-argive-patronage-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/argive_patronage_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-argonauts",
      "file": "techs/greeks-argonauts-64.webp",
      "file128": "techs/greeks-argonauts-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/argonauts_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-ballistics",
      "file": "techs/greeks-ballistics-64.webp",
      "file128": "techs/greeks-ballistics-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/ballistics_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-beast-slayer",
      "file": "techs/greeks-beast-slayer-64.webp",
      "file128": "techs/greeks-beast-slayer-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/beast_slayer_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-boiling-oil",
      "file": "techs/greeks-boiling-oil-64.webp",
      "file128": "techs/greeks-boiling-oil-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/boiling_oil_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-bow-saw",
      "file": "techs/greeks-bow-saw-64.webp",
      "file128": "techs/greeks-bow-saw-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/bow_saw_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-bronze-armor",
      "file": "techs/greeks-bronze-armor-64.webp",
      "file128": "techs/greeks-bronze-armor-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/bronze_armor_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-bronze-shields",
      "file": "techs/greeks-bronze-shields-64.webp",
      "file128": "techs/greeks-bronze-shields-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/bronze_shields_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-bronze-weapons",
      "file": "techs/greeks-bronze-weapons-64.webp",
      "file128": "techs/greeks-bronze-weapons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/bronze_weapons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-burning-pitch",
      "file": "techs/greeks-burning-pitch-64.webp",
      "file128": "techs/greeks-burning-pitch-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/burning_pitch_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-carpenters",
      "file": "techs/greeks-carpenters-64.webp",
      "file128": "techs/greeks-carpenters-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/carpenters_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-carrier-pigeons",
      "file": "techs/greeks-carrier-pigeons-64.webp",
      "file128": "techs/greeks-carrier-pigeons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/carrier_pigeons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-champion-cavalry",
      "file": "techs/greeks-champion-cavalry-64.webp",
      "file128": "techs/greeks-champion-cavalry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/champion_cavalry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-champion-infantry",
      "file": "techs/greeks-champion-infantry-64.webp",
      "file128": "techs/greeks-champion-infantry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/champion_infantry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-champion-ranged-soldiers",
      "file": "techs/greeks-champion-ranged-soldiers-64.webp",
      "file128": "techs/greeks-champion-ranged-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/champion_archers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-champion-warships",
      "file": "techs/greeks-champion-warships-64.webp",
      "file128": "techs/greeks-champion-warships-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/champion_warships_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-chthonic-rites",
      "file": "techs/greeks-chthonic-rites-64.webp",
      "file128": "techs/greeks-chthonic-rites-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/chthonic_rites_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-coinage",
      "file": "techs/greeks-coinage-64.webp",
      "file128": "techs/greeks-coinage-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/coinage_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-conscript-cavalry",
      "file": "techs/greeks-conscript-cavalry-64.webp",
      "file128": "techs/greeks-conscript-cavalry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/conscript_cavalry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-conscript-infantry",
      "file": "techs/greeks-conscript-infantry-64.webp",
      "file128": "techs/greeks-conscript-infantry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/conscript_infantry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-conscript-ranged-soldiers",
      "file": "techs/greeks-conscript-ranged-soldiers-64.webp",
      "file128": "techs/greeks-conscript-ranged-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/conscript_ranged_soldiers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-conscript-sailors",
      "file": "techs/greeks-conscript-sailors-64.webp",
      "file128": "techs/greeks-conscript-sailors-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/conscript_sailors_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-copper-armor",
      "file": "techs/greeks-copper-armor-64.webp",
      "file128": "techs/greeks-copper-armor-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/copper_armor_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-copper-shields",
      "file": "techs/greeks-copper-shields-64.webp",
      "file128": "techs/greeks-copper-shields-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/copper_shields_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-copper-weapons",
      "file": "techs/greeks-copper-weapons-64.webp",
      "file128": "techs/greeks-copper-weapons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/copper_weapons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-crenellations",
      "file": "techs/greeks-crenellations-64.webp",
      "file128": "techs/greeks-crenellations-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/crenellations_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-deimos-sword-of-dread",
      "file": "techs/greeks-deimos-sword-of-dread-64.webp",
      "file128": "techs/greeks-deimos-sword-of-dread-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/deimos_sword_of_dread_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-dionysia",
      "file": "techs/greeks-dionysia-64.webp",
      "file128": "techs/greeks-dionysia-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/dionysia_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-divine-blood",
      "file": "techs/greeks-divine-blood-64.webp",
      "file128": "techs/greeks-divine-blood-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/divine_blood_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-draft-horses",
      "file": "techs/greeks-draft-horses-64.webp",
      "file128": "techs/greeks-draft-horses-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/draft_horses_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-enclosed-deck",
      "file": "techs/greeks-enclosed-deck-64.webp",
      "file128": "techs/greeks-enclosed-deck-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/enclosed_deck_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-engineers",
      "file": "techs/greeks-engineers-64.webp",
      "file128": "techs/greeks-engineers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/engineers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-enyos-bow-of-horror",
      "file": "techs/greeks-enyos-bow-of-horror-64.webp",
      "file128": "techs/greeks-enyos-bow-of-horror-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/enyos_bow_of_horror_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-face-of-the-gorgon",
      "file": "techs/greeks-face-of-the-gorgon-64.webp",
      "file128": "techs/greeks-face-of-the-gorgon-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/face_of_the_gorgon_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-flames-of-typhon",
      "file": "techs/greeks-flames-of-typhon-64.webp",
      "file128": "techs/greeks-flames-of-typhon-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/flames_of_typhon_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-flood-control",
      "file": "techs/greeks-flood-control-64.webp",
      "file128": "techs/greeks-flood-control-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/flood_control_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-forge-of-olympus",
      "file": "techs/greeks-forge-of-olympus-64.webp",
      "file128": "techs/greeks-forge-of-olympus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/forge_of_olympus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-fortified-town-center",
      "file": "techs/greeks-fortified-town-center-64.webp",
      "file128": "techs/greeks-fortified-town-center-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/fortified_town_center_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-fortified-wall",
      "file": "techs/greeks-fortified-wall-64.webp",
      "file128": "techs/greeks-fortified-wall-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/fortified_wall_greek_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-golden-apples",
      "file": "techs/greeks-golden-apples-64.webp",
      "file128": "techs/greeks-golden-apples-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/golden_apples_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-guard-tower",
      "file": "techs/greeks-guard-tower-64.webp",
      "file128": "techs/greeks-guard-tower-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/guard_tower_atlantean_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-hand-axe",
      "file": "techs/greeks-hand-axe-64.webp",
      "file128": "techs/greeks-hand-axe-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/hand_axe_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-hand-of-talos",
      "file": "techs/greeks-hand-of-talos-64.webp",
      "file128": "techs/greeks-hand-of-talos-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/hand_of_talos_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-heavy-cavalry",
      "file": "techs/greeks-heavy-cavalry-64.webp",
      "file128": "techs/greeks-heavy-cavalry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/heavy_cavalry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-heavy-infantry",
      "file": "techs/greeks-heavy-infantry-64.webp",
      "file128": "techs/greeks-heavy-infantry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/heavy_infantry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-heavy-ranged-soldiers",
      "file": "techs/greeks-heavy-ranged-soldiers-64.webp",
      "file128": "techs/greeks-heavy-ranged-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/heavy_archers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-heavy-warships",
      "file": "techs/greeks-heavy-warships-64.webp",
      "file128": "techs/greeks-heavy-warships-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/heavy_warships_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-heroic-fleet",
      "file": "techs/greeks-heroic-fleet-64.webp",
      "file128": "techs/greeks-heroic-fleet-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/heroic_fleet_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-husbandry",
      "file": "techs/greeks-husbandry-64.webp",
      "file128": "techs/greeks-husbandry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/husbandry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-iron-armor",
      "file": "techs/greeks-iron-armor-64.webp",
      "file128": "techs/greeks-iron-armor-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/iron_armor_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-iron-shields",
      "file": "techs/greeks-iron-shields-64.webp",
      "file128": "techs/greeks-iron-shields-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/iron_shields_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-iron-weapons",
      "file": "techs/greeks-iron-weapons-64.webp",
      "file128": "techs/greeks-iron-weapons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/iron_weapons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-irrigation",
      "file": "techs/greeks-irrigation-64.webp",
      "file128": "techs/greeks-irrigation-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/irrigation_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-labyrinth-of-minos",
      "file": "techs/greeks-labyrinth-of-minos-64.webp",
      "file128": "techs/greeks-labyrinth-of-minos-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/labyrinth_of_minos_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-levy-cavalry",
      "file": "techs/greeks-levy-cavalry-64.webp",
      "file128": "techs/greeks-levy-cavalry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/levy_cavalry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-levy-infantry",
      "file": "techs/greeks-levy-infantry-64.webp",
      "file128": "techs/greeks-levy-infantry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/levy_infantry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-levy-ranged-soldiers",
      "file": "techs/greeks-levy-ranged-soldiers-64.webp",
      "file128": "techs/greeks-levy-ranged-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/levy_ranged_soldiers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-lord-of-horses",
      "file": "techs/greeks-lord-of-horses-64.webp",
      "file128": "techs/greeks-lord-of-horses-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/lord_of_horses_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-masons",
      "file": "techs/greeks-masons-64.webp",
      "file128": "techs/greeks-masons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/masons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-medium-cavalry",
      "file": "techs/greeks-medium-cavalry-64.webp",
      "file128": "techs/greeks-medium-cavalry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/medium_cavalry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-medium-infantry",
      "file": "techs/greeks-medium-infantry-64.webp",
      "file128": "techs/greeks-medium-infantry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/medium_infantry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-medium-ranged-soldiers",
      "file": "techs/greeks-medium-ranged-soldiers-64.webp",
      "file128": "techs/greeks-medium-ranged-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/medium_archers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-monstrous-rage",
      "file": "techs/greeks-monstrous-rage-64.webp",
      "file128": "techs/greeks-monstrous-rage-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/monstrous_rage_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-olympian-parentage",
      "file": "techs/greeks-olympian-parentage-64.webp",
      "file128": "techs/greeks-olympian-parentage-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/olympian_parentage_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-olympian-weapons",
      "file": "techs/greeks-olympian-weapons-64.webp",
      "file128": "techs/greeks-olympian-weapons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/olympian_weapons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-omniscience",
      "file": "techs/greeks-omniscience-64.webp",
      "file128": "techs/greeks-omniscience-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/omniscience_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-oracle",
      "file": "techs/greeks-oracle-64.webp",
      "file128": "techs/greeks-oracle-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/oracle_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-phobos-spear-of-panic",
      "file": "techs/greeks-phobos-spear-of-panic-64.webp",
      "file128": "techs/greeks-phobos-spear-of-panic-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/phobos_spear_of_panic_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-pickaxe",
      "file": "techs/greeks-pickaxe-64.webp",
      "file128": "techs/greeks-pickaxe-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/pickaxe_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-plow",
      "file": "techs/greeks-plow-64.webp",
      "file128": "techs/greeks-plow-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/plow_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-purse-seine",
      "file": "techs/greeks-purse-seine-64.webp",
      "file128": "techs/greeks-purse-seine-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/purse_seine_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-quarry",
      "file": "techs/greeks-quarry-64.webp",
      "file128": "techs/greeks-quarry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/quarry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-roar-of-orthus",
      "file": "techs/greeks-roar-of-orthus-64.webp",
      "file128": "techs/greeks-roar-of-orthus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/roar_of_orthus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-salt-amphora",
      "file": "techs/greeks-salt-amphora-64.webp",
      "file128": "techs/greeks-salt-amphora-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/salt_amphora_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-sarissa",
      "file": "techs/greeks-sarissa-64.webp",
      "file128": "techs/greeks-sarissa-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/sarissa_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-shaft-mine",
      "file": "techs/greeks-shaft-mine-64.webp",
      "file128": "techs/greeks-shaft-mine-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/shaft_mine_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-shafts-of-plague",
      "file": "techs/greeks-shafts-of-plague-64.webp",
      "file128": "techs/greeks-shafts-of-plague-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/shafts_of_plague_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-shoulder-of-talos",
      "file": "techs/greeks-shoulder-of-talos-64.webp",
      "file128": "techs/greeks-shoulder-of-talos-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/shoulder_of_talos_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-signal-fires",
      "file": "techs/greeks-signal-fires-64.webp",
      "file128": "techs/greeks-signal-fires-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/signal_fires_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-spirited-charge",
      "file": "techs/greeks-spirited-charge-64.webp",
      "file128": "techs/greeks-spirited-charge-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/spirited_charge_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-stone-wall",
      "file": "techs/greeks-stone-wall-64.webp",
      "file128": "techs/greeks-stone-wall-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/stone_wall_atlantean_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-sun-ray",
      "file": "techs/greeks-sun-ray-64.webp",
      "file128": "techs/greeks-sun-ray-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/sun_ray_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-survival-equipment",
      "file": "techs/greeks-survival-equipment-64.webp",
      "file128": "techs/greeks-survival-equipment-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/hunting_equipment_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-sylvan-lore",
      "file": "techs/greeks-sylvan-lore-64.webp",
      "file128": "techs/greeks-sylvan-lore-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/sylvan_lore_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-tax-collectors",
      "file": "techs/greeks-tax-collectors-64.webp",
      "file128": "techs/greeks-tax-collectors-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/tax_collectors_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-temple-of-healing",
      "file": "techs/greeks-temple-of-healing-64.webp",
      "file128": "techs/greeks-temple-of-healing-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/temple_of_healing_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-thracian-horses",
      "file": "techs/greeks-thracian-horses-64.webp",
      "file128": "techs/greeks-thracian-horses-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/thracian_horses_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-vaults-of-erebus",
      "file": "techs/greeks-vaults-of-erebus-64.webp",
      "file128": "techs/greeks-vaults-of-erebus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/vaults_of_erebus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-watch-tower",
      "file": "techs/greeks-watch-tower-64.webp",
      "file128": "techs/greeks-watch-tower-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/technologies/watch_tower_atlantean_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-will-of-kronos",
      "file": "techs/greeks-will-of-kronos-64.webp",
      "file128": "techs/greeks-will-of-kronos-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/will_of_kronos_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/greeks-winged-messenger",
      "file": "techs/greeks-winged-messenger-64.webp",
      "file128": "techs/greeks-winged-messenger-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/technologies/winged_messenger_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-advanced-fortifications",
      "file": "techs/norse-advanced-fortifications-64.webp",
      "file128": "techs/norse-advanced-fortifications-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/advanced_fortifications_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-ambassadors",
      "file": "techs/norse-ambassadors-64.webp",
      "file128": "techs/norse-ambassadors-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/ambassadors_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-architects",
      "file": "techs/norse-architects-64.webp",
      "file128": "techs/norse-architects-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/architects_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-arctic-winds",
      "file": "techs/norse-arctic-winds-64.webp",
      "file128": "techs/norse-arctic-winds-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/arctic_winds_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-ballistics",
      "file": "techs/norse-ballistics-64.webp",
      "file128": "techs/norse-ballistics-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/ballistics_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-berserkergang",
      "file": "techs/norse-berserkergang-64.webp",
      "file128": "techs/norse-berserkergang-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/berserkergang_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-boiling-oil",
      "file": "techs/norse-boiling-oil-64.webp",
      "file128": "techs/norse-boiling-oil-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/boiling_oil_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-bow-saw",
      "file": "techs/norse-bow-saw-64.webp",
      "file128": "techs/norse-bow-saw-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/bow_saw_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-bravery",
      "file": "techs/norse-bravery-64.webp",
      "file128": "techs/norse-bravery-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/bravery_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-bronze-armor",
      "file": "techs/norse-bronze-armor-64.webp",
      "file128": "techs/norse-bronze-armor-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/bronze_armor_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-bronze-shields",
      "file": "techs/norse-bronze-shields-64.webp",
      "file128": "techs/norse-bronze-shields-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/bronze_shields_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-bronze-weapons",
      "file": "techs/norse-bronze-weapons-64.webp",
      "file128": "techs/norse-bronze-weapons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/bronze_weapons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-burning-pitch",
      "file": "techs/norse-burning-pitch-64.webp",
      "file128": "techs/norse-burning-pitch-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/burning_pitch_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-call-of-valhalla",
      "file": "techs/norse-call-of-valhalla-64.webp",
      "file128": "techs/norse-call-of-valhalla-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/call_of_valhalla_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-carpenters",
      "file": "techs/norse-carpenters-64.webp",
      "file128": "techs/norse-carpenters-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/carpenters_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-carrier-pigeons",
      "file": "techs/norse-carrier-pigeons-64.webp",
      "file128": "techs/norse-carrier-pigeons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/carrier_pigeons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-cave-troll",
      "file": "techs/norse-cave-troll-64.webp",
      "file128": "techs/norse-cave-troll-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/cave_troll_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-champion-cavalry",
      "file": "techs/norse-champion-cavalry-64.webp",
      "file128": "techs/norse-champion-cavalry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/champion_cavalry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-champion-infantry",
      "file": "techs/norse-champion-infantry-64.webp",
      "file128": "techs/norse-champion-infantry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/champion_infantry_norse_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-champion-warships",
      "file": "techs/norse-champion-warships-64.webp",
      "file128": "techs/norse-champion-warships-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/champion_warships_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-coinage",
      "file": "techs/norse-coinage-64.webp",
      "file128": "techs/norse-coinage-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/coinage_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-conscript-great-hall-soldiers",
      "file": "techs/norse-conscript-great-hall-soldiers-64.webp",
      "file128": "techs/norse-conscript-great-hall-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/conscript_great_hall_soldiers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-conscript-hill-fort-soldiers",
      "file": "techs/norse-conscript-hill-fort-soldiers-64.webp",
      "file128": "techs/norse-conscript-hill-fort-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/conscript_hill_fort_soldiers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-conscript-longhouse-soldiers",
      "file": "techs/norse-conscript-longhouse-soldiers-64.webp",
      "file128": "techs/norse-conscript-longhouse-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/conscript_longhouse_soldiers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-conscript-sailors",
      "file": "techs/norse-conscript-sailors-64.webp",
      "file128": "techs/norse-conscript-sailors-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/conscript_sailors_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-copper-armor",
      "file": "techs/norse-copper-armor-64.webp",
      "file128": "techs/norse-copper-armor-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/copper_armor_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-copper-shields",
      "file": "techs/norse-copper-shields-64.webp",
      "file128": "techs/norse-copper-shields-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/copper_shields_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-copper-weapons",
      "file": "techs/norse-copper-weapons-64.webp",
      "file128": "techs/norse-copper-weapons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/copper_weapons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-crenellations",
      "file": "techs/norse-crenellations-64.webp",
      "file128": "techs/norse-crenellations-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/crenellations_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-disablot",
      "file": "techs/norse-disablot-64.webp",
      "file128": "techs/norse-disablot-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/disablot_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-draft-horses",
      "file": "techs/norse-draft-horses-64.webp",
      "file128": "techs/norse-draft-horses-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/draft_horses_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-dragonscale-shields",
      "file": "techs/norse-dragonscale-shields-64.webp",
      "file128": "techs/norse-dragonscale-shields-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/dragonscale_shields_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-dwarven-auger",
      "file": "techs/norse-dwarven-auger-64.webp",
      "file128": "techs/norse-dwarven-auger-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/dwarven_auger_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-dwarven-breastplate",
      "file": "techs/norse-dwarven-breastplate-64.webp",
      "file128": "techs/norse-dwarven-breastplate-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/dwarven_breastplate_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-dwarven-weapons",
      "file": "techs/norse-dwarven-weapons-64.webp",
      "file128": "techs/norse-dwarven-weapons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/dwarven_weapons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-enclosed-deck",
      "file": "techs/norse-enclosed-deck-64.webp",
      "file128": "techs/norse-enclosed-deck-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/enclosed_deck_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-engineers",
      "file": "techs/norse-engineers-64.webp",
      "file128": "techs/norse-engineers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/engineers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-eyes-in-the-forest",
      "file": "techs/norse-eyes-in-the-forest-64.webp",
      "file128": "techs/norse-eyes-in-the-forest-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/eyes_in_the_forest_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-flood-control",
      "file": "techs/norse-flood-control-64.webp",
      "file128": "techs/norse-flood-control-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/flood_control_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-fortified-town-center",
      "file": "techs/norse-fortified-town-center-64.webp",
      "file128": "techs/norse-fortified-town-center-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/fortified_town_center_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-gjallarhorn",
      "file": "techs/norse-gjallarhorn-64.webp",
      "file128": "techs/norse-gjallarhorn-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/gjallarhorn_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-granite-blood",
      "file": "techs/norse-granite-blood-64.webp",
      "file128": "techs/norse-granite-blood-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/granite_blood_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-hall-of-thanes",
      "file": "techs/norse-hall-of-thanes-64.webp",
      "file128": "techs/norse-hall-of-thanes-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/hall_of_thanes_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-hamask",
      "file": "techs/norse-hamask-64.webp",
      "file128": "techs/norse-hamask-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/hamask_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-hammer-of-thunder",
      "file": "techs/norse-hammer-of-thunder-64.webp",
      "file128": "techs/norse-hammer-of-thunder-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/hammer_of_thunder_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-hand-axe",
      "file": "techs/norse-hand-axe-64.webp",
      "file128": "techs/norse-hand-axe-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/hand_axe_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-heavy-cavalry",
      "file": "techs/norse-heavy-cavalry-64.webp",
      "file128": "techs/norse-heavy-cavalry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/heavy_cavalry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-heavy-infantry",
      "file": "techs/norse-heavy-infantry-64.webp",
      "file128": "techs/norse-heavy-infantry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/heavy_infantry_norse_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-heavy-warships",
      "file": "techs/norse-heavy-warships-64.webp",
      "file128": "techs/norse-heavy-warships-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/heavy_warships_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-heroic-fleet",
      "file": "techs/norse-heroic-fleet-64.webp",
      "file128": "techs/norse-heroic-fleet-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/heroic_fleet_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-huntress-axe",
      "file": "techs/norse-huntress-axe-64.webp",
      "file128": "techs/norse-huntress-axe-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/huntress_axe_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-husbandry",
      "file": "techs/norse-husbandry-64.webp",
      "file128": "techs/norse-husbandry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/husbandry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-iron-armor",
      "file": "techs/norse-iron-armor-64.webp",
      "file128": "techs/norse-iron-armor-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/iron_armor_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-iron-shields",
      "file": "techs/norse-iron-shields-64.webp",
      "file128": "techs/norse-iron-shields-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/iron_shields_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-iron-weapons",
      "file": "techs/norse-iron-weapons-64.webp",
      "file128": "techs/norse-iron-weapons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/iron_weapons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-irrigation",
      "file": "techs/norse-irrigation-64.webp",
      "file128": "techs/norse-irrigation-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/irrigation_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-jotuns",
      "file": "techs/norse-jotuns-64.webp",
      "file128": "techs/norse-jotuns-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/jotuns_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-levy-great-hall-soldiers",
      "file": "techs/norse-levy-great-hall-soldiers-64.webp",
      "file128": "techs/norse-levy-great-hall-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/levy_great_hall_soldiers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-levy-hill-fort-soldiers",
      "file": "techs/norse-levy-hill-fort-soldiers-64.webp",
      "file128": "techs/norse-levy-hill-fort-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/levy_hill_fort_soldiers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-levy-longhouse-soldiers",
      "file": "techs/norse-levy-longhouse-soldiers-64.webp",
      "file128": "techs/norse-levy-longhouse-soldiers-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/levy_longhouse_soldiers_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-long-serpent",
      "file": "techs/norse-long-serpent-64.webp",
      "file128": "techs/norse-long-serpent-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/long_serpent_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-masons",
      "file": "techs/norse-masons-64.webp",
      "file128": "techs/norse-masons-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/masons_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-medium-cavalry",
      "file": "techs/norse-medium-cavalry-64.webp",
      "file128": "techs/norse-medium-cavalry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/medium_cavalry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-medium-infantry",
      "file": "techs/norse-medium-infantry-64.webp",
      "file128": "techs/norse-medium-infantry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/medium_infantry_norse_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-meteoric-iron-armor",
      "file": "techs/norse-meteoric-iron-armor-64.webp",
      "file128": "techs/norse-meteoric-iron-armor-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/meteoric_iron_armor_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-omniscience",
      "file": "techs/norse-omniscience-64.webp",
      "file128": "techs/norse-omniscience-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/omniscience_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-pickaxe",
      "file": "techs/norse-pickaxe-64.webp",
      "file128": "techs/norse-pickaxe-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/pickaxe_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-plow",
      "file": "techs/norse-plow-64.webp",
      "file128": "techs/norse-plow-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/plow_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-purse-seine",
      "file": "techs/norse-purse-seine-64.webp",
      "file128": "techs/norse-purse-seine-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/purse_seine_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-quarry",
      "file": "techs/norse-quarry-64.webp",
      "file128": "techs/norse-quarry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/quarry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-rampage",
      "file": "techs/norse-rampage-64.webp",
      "file128": "techs/norse-rampage-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/rampage_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-rigsthula",
      "file": "techs/norse-rigsthula-64.webp",
      "file128": "techs/norse-rigsthula-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/rigsthula_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-rime",
      "file": "techs/norse-rime-64.webp",
      "file128": "techs/norse-rime-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/rime_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-ring-giver",
      "file": "techs/norse-ring-giver-64.webp",
      "file128": "techs/norse-ring-giver-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/ring_giver_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-safeguard",
      "file": "techs/norse-safeguard-64.webp",
      "file128": "techs/norse-safeguard-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/safeguard_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-salt-amphora",
      "file": "techs/norse-salt-amphora-64.webp",
      "file128": "techs/norse-salt-amphora-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/salt_amphora_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-sessrumnir",
      "file": "techs/norse-sessrumnir-64.webp",
      "file128": "techs/norse-sessrumnir-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/sessrumnir_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-shaft-mine",
      "file": "techs/norse-shaft-mine-64.webp",
      "file128": "techs/norse-shaft-mine-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/shaft_mine_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-signal-fires",
      "file": "techs/norse-signal-fires-64.webp",
      "file128": "techs/norse-signal-fires-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/signal_fires_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-sons-of-sleipnir",
      "file": "techs/norse-sons-of-sleipnir-64.webp",
      "file128": "techs/norse-sons-of-sleipnir-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/sons_of_sleipnir_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-stone-wall",
      "file": "techs/norse-stone-wall-64.webp",
      "file128": "techs/norse-stone-wall-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/stone_wall_norse_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-survival-equipment",
      "file": "techs/norse-survival-equipment-64.webp",
      "file128": "techs/norse-survival-equipment-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/hunting_equipment_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-swine-array",
      "file": "techs/norse-swine-array-64.webp",
      "file128": "techs/norse-swine-array-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/swine_array_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-tax-collectors",
      "file": "techs/norse-tax-collectors-64.webp",
      "file128": "techs/norse-tax-collectors-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/shared/static_color/technologies/tax_collectors_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-thundering-hooves",
      "file": "techs/norse-thundering-hooves-64.webp",
      "file128": "techs/norse-thundering-hooves-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/thundering_hooves_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-thurisaz-rune",
      "file": "techs/norse-thurisaz-rune-64.webp",
      "file128": "techs/norse-thurisaz-rune-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/thurisaz_rune_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-vikings",
      "file": "techs/norse-vikings-64.webp",
      "file128": "techs/norse-vikings-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/vikings_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-watch-tower",
      "file": "techs/norse-watch-tower-64.webp",
      "file128": "techs/norse-watch-tower-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/watch_tower_norse_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-winter-harvest",
      "file": "techs/norse-winter-harvest-64.webp",
      "file128": "techs/norse-winter-harvest-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/winter_harvest_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "techs/norse-wrath-of-the-deep",
      "file": "techs/norse-wrath-of-the-deep-64.webp",
      "file128": "techs/norse-wrath-of-the-deep-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/technologies/wrath_of_the_deep_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "ui/pantheon-atlanteans",
      "file": "ui/pantheon-atlanteans-64.webp",
      "file128": "ui/pantheon-atlanteans-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/static_color/major_gods/UI_god_pantheon_Atlantean.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "ui/pantheon-egyptians",
      "file": "ui/pantheon-egyptians-64.webp",
      "file128": "ui/pantheon-egyptians-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/static_color/major_gods/UI_god_pantheon_egyptian.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "ui/pantheon-greeks",
      "file": "ui/pantheon-greeks-64.webp",
      "file128": "ui/pantheon-greeks-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/static_color/major_gods/UI_god_pantheon_Greek.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "ui/pantheon-norse",
      "file": "ui/pantheon-norse-64.webp",
      "file128": "ui/pantheon-norse-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/static_color/major_gods/UI_god_pantheon_Norse.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-arcus",
      "file": "units/atlanteans-arcus-64.webp",
      "file128": "units/atlanteans-arcus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/arcus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-arcus-hero",
      "file": "units/atlanteans-arcus-hero-64.webp",
      "file128": "units/atlanteans-arcus-hero-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/arcus_hero_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-argus",
      "file": "units/atlanteans-argus-64.webp",
      "file128": "units/atlanteans-argus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/argus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-automaton",
      "file": "units/atlanteans-automaton-64.webp",
      "file128": "units/atlanteans-automaton-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/automaton_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-behemoth",
      "file": "units/atlanteans-behemoth-64.webp",
      "file128": "units/atlanteans-behemoth-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/behemoth_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-bireme",
      "file": "units/atlanteans-bireme-64.webp",
      "file128": "units/atlanteans-bireme-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/bireme_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-caladria",
      "file": "units/atlanteans-caladria-64.webp",
      "file128": "units/atlanteans-caladria-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/caladria_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-centimanus",
      "file": "units/atlanteans-centimanus-64.webp",
      "file128": "units/atlanteans-centimanus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/centimanus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-cheiroballista",
      "file": "units/atlanteans-cheiroballista-64.webp",
      "file128": "units/atlanteans-cheiroballista-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/cheiroballista_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-cheiroballista-hero",
      "file": "units/atlanteans-cheiroballista-hero-64.webp",
      "file128": "units/atlanteans-cheiroballista-hero-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/cheiroballista_hero_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-citizen",
      "file": "units/atlanteans-citizen-64.webp",
      "file128": "units/atlanteans-citizen-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/villager_atlantean_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-citizen-hero",
      "file": "units/atlanteans-citizen-hero-64.webp",
      "file128": "units/atlanteans-citizen-hero-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/villager_atlantean_hero_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-contarius",
      "file": "units/atlanteans-contarius-64.webp",
      "file128": "units/atlanteans-contarius-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/contarius_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-contarius-hero",
      "file": "units/atlanteans-contarius-hero-64.webp",
      "file128": "units/atlanteans-contarius-hero-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/contarius_hero_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-destroyer",
      "file": "units/atlanteans-destroyer-64.webp",
      "file128": "units/atlanteans-destroyer-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/destroyer_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-destroyer-hero",
      "file": "units/atlanteans-destroyer-hero-64.webp",
      "file128": "units/atlanteans-destroyer-hero-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/destroyer_hero_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-dryad",
      "file": "units/atlanteans-dryad-64.webp",
      "file128": "units/atlanteans-dryad-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/dryad_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-fanatic",
      "file": "units/atlanteans-fanatic-64.webp",
      "file128": "units/atlanteans-fanatic-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/fanatic_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-fanatic-hero",
      "file": "units/atlanteans-fanatic-hero-64.webp",
      "file128": "units/atlanteans-fanatic-hero-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/fanatic_hero_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-fire-ship",
      "file": "units/atlanteans-fire-ship-64.webp",
      "file128": "units/atlanteans-fire-ship-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/fire_ship_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-fire-siphon",
      "file": "units/atlanteans-fire-siphon-64.webp",
      "file128": "units/atlanteans-fire-siphon-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/fire_siphon_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-fishing-ship",
      "file": "units/atlanteans-fishing-ship-64.webp",
      "file128": "units/atlanteans-fishing-ship-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/fishing_ship_atlantean_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-katapeltes",
      "file": "units/atlanteans-katapeltes-64.webp",
      "file128": "units/atlanteans-katapeltes-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/katapeltes_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-katapeltes-hero",
      "file": "units/atlanteans-katapeltes-hero-64.webp",
      "file128": "units/atlanteans-katapeltes-hero-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/katapeltes_hero_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-lampades",
      "file": "units/atlanteans-lampades-64.webp",
      "file128": "units/atlanteans-lampades-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/lampades_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-llama-caravan",
      "file": "units/atlanteans-llama-caravan-64.webp",
      "file128": "units/atlanteans-llama-caravan-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/caravan_atlantean_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-man-o-war",
      "file": "units/atlanteans-man-o-war-64.webp",
      "file128": "units/atlanteans-man-o-war-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/man_o_war_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-murmillo",
      "file": "units/atlanteans-murmillo-64.webp",
      "file128": "units/atlanteans-murmillo-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/murmillo_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-murmillo-hero",
      "file": "units/atlanteans-murmillo-hero-64.webp",
      "file128": "units/atlanteans-murmillo-hero-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/murmillo_hero_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-nereid",
      "file": "units/atlanteans-nereid-64.webp",
      "file128": "units/atlanteans-nereid-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/nereid_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-oracle",
      "file": "units/atlanteans-oracle-64.webp",
      "file128": "units/atlanteans-oracle-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/oracle_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-oracle-hero",
      "file": "units/atlanteans-oracle-hero-64.webp",
      "file128": "units/atlanteans-oracle-hero-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/oracle_hero_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-promethean",
      "file": "units/atlanteans-promethean-64.webp",
      "file128": "units/atlanteans-promethean-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/promethean_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-satyr",
      "file": "units/atlanteans-satyr-64.webp",
      "file128": "units/atlanteans-satyr-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/satyr_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-servant",
      "file": "units/atlanteans-servant-64.webp",
      "file128": "units/atlanteans-servant-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/servant_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-siege-bireme",
      "file": "units/atlanteans-siege-bireme-64.webp",
      "file128": "units/atlanteans-siege-bireme-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/siege_bireme_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-stymphalian-bird",
      "file": "units/atlanteans-stymphalian-bird-64.webp",
      "file128": "units/atlanteans-stymphalian-bird-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/stymphalian_bird_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-transport-ship",
      "file": "units/atlanteans-transport-ship-64.webp",
      "file128": "units/atlanteans-transport-ship-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/transport_ship_atlantean_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-turma",
      "file": "units/atlanteans-turma-64.webp",
      "file128": "units/atlanteans-turma-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/turma_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/atlanteans-turma-hero",
      "file": "units/atlanteans-turma-hero-64.webp",
      "file128": "units/atlanteans-turma-hero-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/atlantean/player_color/units/turma_hero_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-anubite",
      "file": "units/egyptians-anubite-64.webp",
      "file128": "units/egyptians-anubite-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/anubite_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-avenger",
      "file": "units/egyptians-avenger-64.webp",
      "file128": "units/egyptians-avenger-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/avenger_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-axeman",
      "file": "units/egyptians-axeman-64.webp",
      "file128": "units/egyptians-axeman-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/axeman_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-baboon-of-set",
      "file": "units/egyptians-baboon-of-set-64.webp",
      "file128": "units/egyptians-baboon-of-set-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/baboon_of_set_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-camel-caravan",
      "file": "units/egyptians-camel-caravan-64.webp",
      "file128": "units/egyptians-camel-caravan-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/caravan_egyptian_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-camel-rider",
      "file": "units/egyptians-camel-rider-64.webp",
      "file128": "units/egyptians-camel-rider-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/camel_rider_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-catapult",
      "file": "units/egyptians-catapult-64.webp",
      "file128": "units/egyptians-catapult-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/catapult_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-chariot-archer",
      "file": "units/egyptians-chariot-archer-64.webp",
      "file128": "units/egyptians-chariot-archer-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/chariot_archer_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-crocodile-of-set",
      "file": "units/egyptians-crocodile-of-set-64.webp",
      "file128": "units/egyptians-crocodile-of-set-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/crocodile_of_set_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-elephant-of-set",
      "file": "units/egyptians-elephant-of-set-64.webp",
      "file128": "units/egyptians-elephant-of-set-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/elephant_of_set_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-fishing-ship",
      "file": "units/egyptians-fishing-ship-64.webp",
      "file128": "units/egyptians-fishing-ship-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/fishing_ship_egyptian_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-gazelle-of-set",
      "file": "units/egyptians-gazelle-of-set-64.webp",
      "file128": "units/egyptians-gazelle-of-set-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/gazelle_of_set_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-giraffe-of-set",
      "file": "units/egyptians-giraffe-of-set-64.webp",
      "file128": "units/egyptians-giraffe-of-set-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/giraffe_of_set_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-hippopotamus-of-set",
      "file": "units/egyptians-hippopotamus-of-set-64.webp",
      "file128": "units/egyptians-hippopotamus-of-set-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/hippopotamus_of_set_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-hyena-of-set",
      "file": "units/egyptians-hyena-of-set-64.webp",
      "file128": "units/egyptians-hyena-of-set-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/hyena_of_set_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-kebenit",
      "file": "units/egyptians-kebenit-64.webp",
      "file128": "units/egyptians-kebenit-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/kebenit_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-laborer",
      "file": "units/egyptians-laborer-64.webp",
      "file128": "units/egyptians-laborer-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/villager_egyptian_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-leviathan",
      "file": "units/egyptians-leviathan-64.webp",
      "file128": "units/egyptians-leviathan-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/leviathan_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-mercenary",
      "file": "units/egyptians-mercenary-64.webp",
      "file128": "units/egyptians-mercenary-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/mercenary_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-mercenary-cavalry",
      "file": "units/egyptians-mercenary-cavalry-64.webp",
      "file128": "units/egyptians-mercenary-cavalry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/mercenary_cavalry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-mummy",
      "file": "units/egyptians-mummy-64.webp",
      "file128": "units/egyptians-mummy-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/mummy_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-petsuchos",
      "file": "units/egyptians-petsuchos-64.webp",
      "file128": "units/egyptians-petsuchos-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/petsuchos_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-pharaoh",
      "file": "units/egyptians-pharaoh-64.webp",
      "file128": "units/egyptians-pharaoh-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/pharaoh_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-pharaoh-new-kingdom",
      "file": "units/egyptians-pharaoh-new-kingdom-64.webp",
      "file128": "units/egyptians-pharaoh-new-kingdom-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/pharaoh_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-phoenix",
      "file": "units/egyptians-phoenix-64.webp",
      "file128": "units/egyptians-phoenix-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/phoenix_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-priest",
      "file": "units/egyptians-priest-64.webp",
      "file128": "units/egyptians-priest-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/priest_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-ramming-galley",
      "file": "units/egyptians-ramming-galley-64.webp",
      "file128": "units/egyptians-ramming-galley-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/ramming_galley_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-rhinoceros-of-set",
      "file": "units/egyptians-rhinoceros-of-set-64.webp",
      "file128": "units/egyptians-rhinoceros-of-set-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/rhinoceros_of_set_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-roc",
      "file": "units/egyptians-roc-64.webp",
      "file128": "units/egyptians-roc-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/roc_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-scarab",
      "file": "units/egyptians-scarab-64.webp",
      "file128": "units/egyptians-scarab-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/scarab_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-scorpion-man",
      "file": "units/egyptians-scorpion-man-64.webp",
      "file128": "units/egyptians-scorpion-man-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/scorpion_man_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-siege-tower",
      "file": "units/egyptians-siege-tower-64.webp",
      "file128": "units/egyptians-siege-tower-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/siege_tower_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-slinger",
      "file": "units/egyptians-slinger-64.webp",
      "file128": "units/egyptians-slinger-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/slinger_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-spearman",
      "file": "units/egyptians-spearman-64.webp",
      "file128": "units/egyptians-spearman-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/spearman_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-sphinx",
      "file": "units/egyptians-sphinx-64.webp",
      "file128": "units/egyptians-sphinx-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/sphinx_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-transport-ship",
      "file": "units/egyptians-transport-ship-64.webp",
      "file128": "units/egyptians-transport-ship-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/transport_ship_egyptian_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-wadjet",
      "file": "units/egyptians-wadjet-64.webp",
      "file128": "units/egyptians-wadjet-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/wadjet_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-war-barge",
      "file": "units/egyptians-war-barge-64.webp",
      "file128": "units/egyptians-war-barge-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/war_barge_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-war-elephant",
      "file": "units/egyptians-war-elephant-64.webp",
      "file128": "units/egyptians-war-elephant-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/war_elephant_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/egyptians-war-turtle",
      "file": "units/egyptians-war-turtle-64.webp",
      "file128": "units/egyptians-war-turtle-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/egyptian/player_color/units/war_turtle_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-achilles",
      "file": "units/greeks-achilles-64.webp",
      "file128": "units/greeks-achilles-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/achilles_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-ajax",
      "file": "units/greeks-ajax-64.webp",
      "file128": "units/greeks-ajax-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/ajax_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-atalanta",
      "file": "units/greeks-atalanta-64.webp",
      "file128": "units/greeks-atalanta-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/atalanta_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-bellerophon",
      "file": "units/greeks-bellerophon-64.webp",
      "file128": "units/greeks-bellerophon-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/bellerophon_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-caravan",
      "file": "units/greeks-caravan-64.webp",
      "file128": "units/greeks-caravan-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/caravan_greek_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-carcinos",
      "file": "units/greeks-carcinos-64.webp",
      "file128": "units/greeks-carcinos-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/carcinos_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-centaur",
      "file": "units/greeks-centaur-64.webp",
      "file128": "units/greeks-centaur-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/centaur_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-chimera",
      "file": "units/greeks-chimera-64.webp",
      "file128": "units/greeks-chimera-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/chimera_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-chiron",
      "file": "units/greeks-chiron-64.webp",
      "file128": "units/greeks-chiron-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/chiron_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-colossus",
      "file": "units/greeks-colossus-64.webp",
      "file128": "units/greeks-colossus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/colossus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-cyclops",
      "file": "units/greeks-cyclops-64.webp",
      "file128": "units/greeks-cyclops-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/cyclops_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-fishing-ship",
      "file": "units/greeks-fishing-ship-64.webp",
      "file128": "units/greeks-fishing-ship-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/fishing_ship_greek_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-gastraphetoros",
      "file": "units/greeks-gastraphetoros-64.webp",
      "file128": "units/greeks-gastraphetoros-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/gastraphetoros_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-helepolis",
      "file": "units/greeks-helepolis-64.webp",
      "file128": "units/greeks-helepolis-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/helepolis_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-heracles",
      "file": "units/greeks-heracles-64.webp",
      "file128": "units/greeks-heracles-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/heracles_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-hetairos",
      "file": "units/greeks-hetairos-64.webp",
      "file128": "units/greeks-hetairos-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/hetairos_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-hippeus",
      "file": "units/greeks-hippeus-64.webp",
      "file128": "units/greeks-hippeus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/hippeus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-hippocampus",
      "file": "units/greeks-hippocampus-64.webp",
      "file128": "units/greeks-hippocampus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/hippocampus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-hippolyta",
      "file": "units/greeks-hippolyta-64.webp",
      "file128": "units/greeks-hippolyta-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/hippolyta_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-hoplite",
      "file": "units/greeks-hoplite-64.webp",
      "file128": "units/greeks-hoplite-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/hoplite_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-hydra",
      "file": "units/greeks-hydra-64.webp",
      "file128": "units/greeks-hydra-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/hydra_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-hypaspist",
      "file": "units/greeks-hypaspist-64.webp",
      "file128": "units/greeks-hypaspist-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/hypaspist_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-jason",
      "file": "units/greeks-jason-64.webp",
      "file128": "units/greeks-jason-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache.bar/resources/greek/player_color/units/jason_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-juggernaut",
      "file": "units/greeks-juggernaut-64.webp",
      "file128": "units/greeks-juggernaut-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/juggernaut_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-kataskopos",
      "file": "units/greeks-kataskopos-64.webp",
      "file128": "units/greeks-kataskopos-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/kataskopos_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-manticore",
      "file": "units/greeks-manticore-64.webp",
      "file128": "units/greeks-manticore-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/manticore_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-medusa",
      "file": "units/greeks-medusa-64.webp",
      "file128": "units/greeks-medusa-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/medusa_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-militia",
      "file": "units/greeks-militia-64.webp",
      "file128": "units/greeks-militia-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/militia_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-minotaur",
      "file": "units/greeks-minotaur-64.webp",
      "file128": "units/greeks-minotaur-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/minotaur_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-myrmidon",
      "file": "units/greeks-myrmidon-64.webp",
      "file128": "units/greeks-myrmidon-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/myrmidon_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-nemean-lion",
      "file": "units/greeks-nemean-lion-64.webp",
      "file128": "units/greeks-nemean-lion-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/nemean_lion_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-odysseus",
      "file": "units/greeks-odysseus-64.webp",
      "file128": "units/greeks-odysseus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/odysseus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-pegasus",
      "file": "units/greeks-pegasus-64.webp",
      "file128": "units/greeks-pegasus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/pegasus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-peltast",
      "file": "units/greeks-peltast-64.webp",
      "file128": "units/greeks-peltast-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/peltast_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-pentekonter",
      "file": "units/greeks-pentekonter-64.webp",
      "file128": "units/greeks-pentekonter-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/pentekonter_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-perseus",
      "file": "units/greeks-perseus-64.webp",
      "file128": "units/greeks-perseus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/perseus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-petrobolos",
      "file": "units/greeks-petrobolos-64.webp",
      "file128": "units/greeks-petrobolos-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/petrobolos_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-polyphemus",
      "file": "units/greeks-polyphemus-64.webp",
      "file128": "units/greeks-polyphemus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/polyphemus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-prodromos",
      "file": "units/greeks-prodromos-64.webp",
      "file128": "units/greeks-prodromos-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/prodromos_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-scylla",
      "file": "units/greeks-scylla-64.webp",
      "file128": "units/greeks-scylla-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/scylla_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-shade-of-hades",
      "file": "units/greeks-shade-of-hades-64.webp",
      "file128": "units/greeks-shade-of-hades-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/hades_shade_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-the-argo",
      "file": "units/greeks-the-argo-64.webp",
      "file128": "units/greeks-the-argo-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/the_argo_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-theseus",
      "file": "units/greeks-theseus-64.webp",
      "file128": "units/greeks-theseus-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/theseus_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-toxotes",
      "file": "units/greeks-toxotes-64.webp",
      "file128": "units/greeks-toxotes-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/toxotes_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-transport-ship",
      "file": "units/greeks-transport-ship-64.webp",
      "file128": "units/greeks-transport-ship-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/transport_ship_greek_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-trireme",
      "file": "units/greeks-trireme-64.webp",
      "file128": "units/greeks-trireme-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/trireme_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/greeks-villager",
      "file": "units/greeks-villager-64.webp",
      "file128": "units/greeks-villager-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/greek/player_color/units/villager_greek_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-ballista",
      "file": "units/norse-ballista-64.webp",
      "file128": "units/norse-ballista-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/ballista_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-battle-boar",
      "file": "units/norse-battle-boar-64.webp",
      "file128": "units/norse-battle-boar-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/battle_boar_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-berserk",
      "file": "units/norse-berserk-64.webp",
      "file128": "units/norse-berserk-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/berserk_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-dragon-ship",
      "file": "units/norse-dragon-ship-64.webp",
      "file128": "units/norse-dragon-ship-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/dragon_ship_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-dreki",
      "file": "units/norse-dreki-64.webp",
      "file128": "units/norse-dreki-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/dreki_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-dwarf",
      "file": "units/norse-dwarf-64.webp",
      "file128": "units/norse-dwarf-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/villager_dwarf_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-einheri",
      "file": "units/norse-einheri-64.webp",
      "file128": "units/norse-einheri-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/einheri_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-fenris-wolf-brood",
      "file": "units/norse-fenris-wolf-brood-64.webp",
      "file128": "units/norse-fenris-wolf-brood-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/fenris_wolf_brood_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-fire-giant",
      "file": "units/norse-fire-giant-64.webp",
      "file128": "units/norse-fire-giant-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/fire_giant_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-fishing-ship",
      "file": "units/norse-fishing-ship-64.webp",
      "file128": "units/norse-fishing-ship-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/fishing_ship_norse_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-frost-giant",
      "file": "units/norse-frost-giant-64.webp",
      "file128": "units/norse-frost-giant-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/frost_giant_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-gatherer",
      "file": "units/norse-gatherer-64.webp",
      "file128": "units/norse-gatherer-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/villager_norse_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-godi",
      "file": "units/norse-godi-64.webp",
      "file128": "units/norse-godi-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/godi_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-hersir",
      "file": "units/norse-hersir-64.webp",
      "file128": "units/norse-hersir-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/hersir_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-hirdman",
      "file": "units/norse-hirdman-64.webp",
      "file128": "units/norse-hirdman-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/hirdman_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-huskarl",
      "file": "units/norse-huskarl-64.webp",
      "file128": "units/norse-huskarl-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/huskarl_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-jarl",
      "file": "units/norse-jarl-64.webp",
      "file128": "units/norse-jarl-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/jarl_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-jormun-elver",
      "file": "units/norse-jormun-elver-64.webp",
      "file128": "units/norse-jormun-elver-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/jormun_elver_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-kraken",
      "file": "units/norse-kraken-64.webp",
      "file128": "units/norse-kraken-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/kraken_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-longboat",
      "file": "units/norse-longboat-64.webp",
      "file128": "units/norse-longboat-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/longboat_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-mountain-giant",
      "file": "units/norse-mountain-giant-64.webp",
      "file128": "units/norse-mountain-giant-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/mountain_giant_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-ox-caravan",
      "file": "units/norse-ox-caravan-64.webp",
      "file128": "units/norse-ox-caravan-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/caravan_norse_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-portable-ram",
      "file": "units/norse-portable-ram-64.webp",
      "file128": "units/norse-portable-ram-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/portable_ram_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-raiding-cavalry",
      "file": "units/norse-raiding-cavalry-64.webp",
      "file128": "units/norse-raiding-cavalry-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/raiding_cavalry_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-throwing-axeman",
      "file": "units/norse-throwing-axeman-64.webp",
      "file128": "units/norse-throwing-axeman-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/throwing_axeman_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-transport-ship",
      "file": "units/norse-transport-ship-64.webp",
      "file128": "units/norse-transport-ship-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/transport_ship_norse_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-troll",
      "file": "units/norse-troll-64.webp",
      "file128": "units/norse-troll-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/troll_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    },
    {
      "id": "units/norse-valkyrie",
      "file": "units/norse-valkyrie-64.webp",
      "file128": "units/norse-valkyrie-128.webp",
      "origin": "Game files 19.17020 (game/ui/UITextureCache4K.bar/resources/norse/player_color/units/valkyrie_icon.dds)",
      "license": "Game asset © Microsoft; fan use under the Game Content Usage Rules"
    }
  ]
}
